/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/app'
import { Route as PublicRouteImport } from './routes/_public'
import { Route as AppIndexRouteImport } from './routes/app/index'
import { Route as PublicIndexRouteImport } from './routes/_public.index'
import { Route as AppSettingsRouteImport } from './routes/app/settings'
import { Route as AppCustomerRouteImport } from './routes/app/$customer'
import { Route as PublicRepairRouteImport } from './routes/_public.repair'
import { Route as PublicRegisterRouteImport } from './routes/_public.register'
import { Route as PublicPrivacyRouteImport } from './routes/_public.privacy'
import { Route as PublicLoginRouteImport } from './routes/_public.login'
import { Route as PublicCompleteRegistrationRouteImport } from './routes/_public.complete-registration'
import { Route as AppSettingsIndexRouteImport } from './routes/app/settings.index'
import { Route as AppCustomerIndexRouteImport } from './routes/app/$customer/index'
import { Route as AppSettingsFsmWorkflowsRouteImport } from './routes/app/settings/fsm-workflows'
import { Route as AppSettingsCustomersRouteImport } from './routes/app/settings/customers'
import { Route as AppCCustomerSlugRouteImport } from './routes/app/c.$customerSlug'
import { Route as AppAdminUsersRouteImport } from './routes/app/admin/users'
import { Route as AppAdminStationsRouteImport } from './routes/app/admin/stations'
import { Route as AppAdminRolesRouteImport } from './routes/app/admin/roles'
import { Route as AppAdminNotificationChannelsRouteImport } from './routes/app/admin/notification-channels'
import { Route as AppAdminMaterialsRouteImport } from './routes/app/admin/materials'
import { Route as AppAdminMapRouteImport } from './routes/app/admin/map'
import { Route as AppAdminLocationsRouteImport } from './routes/app/admin/locations'
import { Route as AppAdminKpisRouteImport } from './routes/app/admin/kpis'
import { Route as AppAdminFsmWorkflowsRouteImport } from './routes/app/admin/fsm-workflows'
import { Route as AppAdminFsmRouteImport } from './routes/app/admin/fsm'
import { Route as AppAdminDevicesRouteImport } from './routes/app/admin/devices'
import { Route as AppAdminCustomersRouteImport } from './routes/app/admin/customers'
import { Route as AppAdminBikesRouteImport } from './routes/app/admin/bikes'
import { Route as AppAdminBikeModelsRouteImport } from './routes/app/admin/bike-models'
import { Route as AppSettingsCustomersIndexRouteImport } from './routes/app/settings/customers.index'
import { Route as AppAdminUsersIndexRouteImport } from './routes/app/admin/users.index'
import { Route as AppAdminStationsIndexRouteImport } from './routes/app/admin/stations.index'
import { Route as AppAdminRolesIndexRouteImport } from './routes/app/admin/roles.index'
import { Route as AppAdminNotificationChannelsIndexRouteImport } from './routes/app/admin/notification-channels.index'
import { Route as AppAdminMaterialsIndexRouteImport } from './routes/app/admin/materials.index'
import { Route as AppAdminMapIndexRouteImport } from './routes/app/admin/map.index'
import { Route as AppAdminLocationsIndexRouteImport } from './routes/app/admin/locations.index'
import { Route as AppAdminKpisIndexRouteImport } from './routes/app/admin/kpis.index'
import { Route as AppAdminFsmIndexRouteImport } from './routes/app/admin/fsm.index'
import { Route as AppAdminFsmWorkflowsIndexRouteImport } from './routes/app/admin/fsm-workflows.index'
import { Route as AppAdminDevicesIndexRouteImport } from './routes/app/admin/devices.index'
import { Route as AppAdminCustomersIndexRouteImport } from './routes/app/admin/customers.index'
import { Route as AppAdminBikesIndexRouteImport } from './routes/app/admin/bikes.index'
import { Route as AppAdminBikeModelsIndexRouteImport } from './routes/app/admin/bike-models.index'
import { Route as AppCustomerRequestsIndexRouteImport } from './routes/app/$customer/requests.index'
import { Route as AppCCustomerSlugTrackingRouteImport } from './routes/app/c.$customerSlug/tracking'
import { Route as AppCCustomerSlugMaterialsRouteImport } from './routes/app/c.$customerSlug/materials'
import { Route as AppCCustomerSlugLocationsRouteImport } from './routes/app/c.$customerSlug/locations'
import { Route as AppCCustomerSlugBikesRouteImport } from './routes/app/c.$customerSlug/bikes'
import { Route as AppCCustomerSlugBikeModelsRouteImport } from './routes/app/c.$customerSlug/bike-models'
import { Route as AppAdminUsersInviteRouteImport } from './routes/app/admin/users.invite'
import { Route as AppAdminUsersIdRouteImport } from './routes/app/admin/users.$id'
import { Route as AppAdminStationsNewRouteImport } from './routes/app/admin/stations.new'
import { Route as AppAdminStationsIdRouteImport } from './routes/app/admin/stations.$id'
import { Route as AppAdminRolesIdRouteImport } from './routes/app/admin/roles.$id'
import { Route as AppAdminMaterialsNewRouteImport } from './routes/app/admin/materials.new'
import { Route as AppAdminMaterialsImportRelationsRouteImport } from './routes/app/admin/materials.import-relations'
import { Route as AppAdminMaterialsImportRouteImport } from './routes/app/admin/materials.import'
import { Route as AppAdminMaterialsIdRouteImport } from './routes/app/admin/materials.$id'
import { Route as AppAdminLocationsNewRouteImport } from './routes/app/admin/locations.new'
import { Route as AppAdminLocationsIdRouteImport } from './routes/app/admin/locations.$id'
import { Route as AppAdminDevicesNewRouteImport } from './routes/app/admin/devices.new'
import { Route as AppAdminDevicesIdRouteImport } from './routes/app/admin/devices.$id'
import { Route as AppAdminBikesNewRouteImport } from './routes/app/admin/bikes.new'
import { Route as AppAdminBikesIdRouteImport } from './routes/app/admin/bikes.$id'
import { Route as AppAdminBikeModelsNewRouteImport } from './routes/app/admin/bike-models.new'
import { Route as AppAdminBikeModelsIdRouteImport } from './routes/app/admin/bike-models.$id'
import { Route as AppCustomerRequestsNewRouteImport } from './routes/app/$customer/requests.new'
import { Route as AppCustomerRequestsIdRouteImport } from './routes/app/$customer/requests.$id'
import { Route as AppCCustomerSlugTrackingIndexRouteImport } from './routes/app/c.$customerSlug/tracking.index'
import { Route as AppCCustomerSlugRequestsIndexRouteImport } from './routes/app/c.$customerSlug/requests.index'
import { Route as AppCCustomerSlugMaterialsIndexRouteImport } from './routes/app/c.$customerSlug/materials.index'
import { Route as AppCCustomerSlugLocationsIndexRouteImport } from './routes/app/c.$customerSlug/locations.index'
import { Route as AppCCustomerSlugBikesIndexRouteImport } from './routes/app/c.$customerSlug/bikes.index'
import { Route as AppCCustomerSlugBikeModelsIndexRouteImport } from './routes/app/c.$customerSlug/bike-models.index'
import { Route as AppAdminMaterialsIdIndexRouteImport } from './routes/app/admin/materials.$id.index'
import { Route as AppAdminFsmTransitionsIndexRouteImport } from './routes/app/admin/fsm.transitions.index'
import { Route as AppAdminFsmStatesIndexRouteImport } from './routes/app/admin/fsm.states.index'
import { Route as AppAdminFsmEntityTypesIndexRouteImport } from './routes/app/admin/fsm.entity-types.index'
import { Route as AppAdminFsmEntitiesIndexRouteImport } from './routes/app/admin/fsm.entities.index'
import { Route as AppAdminFsmDocumentTypesIndexRouteImport } from './routes/app/admin/fsm.document-types.index'
import { Route as AppAdminFsmWorkflowsTransitionsIndexRouteImport } from './routes/app/admin/fsm-workflows.transitions.index'
import { Route as AppAdminFsmWorkflowsStatesIndexRouteImport } from './routes/app/admin/fsm-workflows.states.index'
import { Route as AppAdminFsmWorkflowsEntityTypesIndexRouteImport } from './routes/app/admin/fsm-workflows.entity-types.index'
import { Route as AppAdminFsmWorkflowsEntitiesIndexRouteImport } from './routes/app/admin/fsm-workflows.entities.index'
import { Route as AppAdminFsmWorkflowsDocumentTypesIndexRouteImport } from './routes/app/admin/fsm-workflows.document-types.index'
import { Route as AppAdminBikeModelsIdIndexRouteImport } from './routes/app/admin/bike-models.$id.index'
import { Route as AppCCustomerSlugRequestsNewRouteImport } from './routes/app/c.$customerSlug/requests.new'
import { Route as AppCCustomerSlugRequestsIdRouteImport } from './routes/app/c.$customerSlug/requests.$id'
import { Route as AppCCustomerSlugReportingMaterialsBudgetRouteImport } from './routes/app/c.$customerSlug/reporting.materials-budget'
import { Route as AppCCustomerSlugReportingKpiOpsRouteImport } from './routes/app/c.$customerSlug/reporting.kpi-ops'
import { Route as AppCCustomerSlugMaterialsNewRouteImport } from './routes/app/c.$customerSlug/materials.new'
import { Route as AppCCustomerSlugMaterialsImportRelationsRouteImport } from './routes/app/c.$customerSlug/materials.import-relations'
import { Route as AppCCustomerSlugMaterialsImportRouteImport } from './routes/app/c.$customerSlug/materials.import'
import { Route as AppCCustomerSlugMaterialsIdRouteImport } from './routes/app/c.$customerSlug/materials.$id'
import { Route as AppCCustomerSlugLocationsNewRouteImport } from './routes/app/c.$customerSlug/locations.new'
import { Route as AppCCustomerSlugLocationsIdRouteImport } from './routes/app/c.$customerSlug/locations.$id'
import { Route as AppCCustomerSlugDDocTypeSlugRouteImport } from './routes/app/c.$customerSlug/d.$docTypeSlug'
import { Route as AppCCustomerSlugBikesNewRouteImport } from './routes/app/c.$customerSlug/bikes.new'
import { Route as AppCCustomerSlugBikesIdRouteImport } from './routes/app/c.$customerSlug/bikes.$id'
import { Route as AppCCustomerSlugBikeModelsNewRouteImport } from './routes/app/c.$customerSlug/bike-models.new'
import { Route as AppCCustomerSlugBikeModelsIdRouteImport } from './routes/app/c.$customerSlug/bike-models.$id'
import { Route as AppAdminMaterialsIdBikeModelsRouteImport } from './routes/app/admin/materials.$id.bike-models'
import { Route as AppAdminFsmTransitionsIdRouteImport } from './routes/app/admin/fsm.transitions.$id'
import { Route as AppAdminFsmStatesIdRouteImport } from './routes/app/admin/fsm.states.$id'
import { Route as AppAdminFsmEntityTypesIdRouteImport } from './routes/app/admin/fsm.entity-types.$id'
import { Route as AppAdminFsmEntitiesIdRouteImport } from './routes/app/admin/fsm.entities.$id'
import { Route as AppAdminFsmDocumentTypesIdRouteImport } from './routes/app/admin/fsm.document-types.$id'
import { Route as AppAdminFsmWorkflowsTransitionsIdRouteImport } from './routes/app/admin/fsm-workflows.transitions.$id'
import { Route as AppAdminFsmWorkflowsStatesIdRouteImport } from './routes/app/admin/fsm-workflows.states.$id'
import { Route as AppAdminFsmWorkflowsEntityTypesIdRouteImport } from './routes/app/admin/fsm-workflows.entity-types.$id'
import { Route as AppAdminFsmWorkflowsEntitiesIdRouteImport } from './routes/app/admin/fsm-workflows.entities.$id'
import { Route as AppAdminFsmWorkflowsDocumentTypesIdRouteImport } from './routes/app/admin/fsm-workflows.document-types.$id'
import { Route as AppAdminBikeModelsIdMaterialsRouteImport } from './routes/app/admin/bike-models.$id.materials'
import { Route as AppCCustomerSlugReportingMaterialsBudgetIndexRouteImport } from './routes/app/c.$customerSlug/reporting.materials-budget.index'
import { Route as AppCCustomerSlugReportingKpiOpsIndexRouteImport } from './routes/app/c.$customerSlug/reporting.kpi-ops.index'
import { Route as AppCCustomerSlugMaterialsIdIndexRouteImport } from './routes/app/c.$customerSlug/materials.$id.index'
import { Route as AppCCustomerSlugDDocTypeSlugIndexRouteImport } from './routes/app/c.$customerSlug/d.$docTypeSlug.index'
import { Route as AppCCustomerSlugBikeModelsIdIndexRouteImport } from './routes/app/c.$customerSlug/bike-models.$id.index'
import { Route as AppCCustomerSlugMaterialsIdBikeModelsRouteImport } from './routes/app/c.$customerSlug/materials.$id.bike-models'
import { Route as AppCCustomerSlugDDocTypeSlugDocumentIdRouteImport } from './routes/app/c.$customerSlug/d.$docTypeSlug.$documentId'
import { Route as AppCCustomerSlugBikeModelsIdMaterialsRouteImport } from './routes/app/c.$customerSlug/bike-models.$id.materials'

const AppAdminFsmWorkflowsIndexLazyRouteImport = createFileRoute(
  '/app/admin/fsm/workflows/',
)()
const AppAdminFsmWorkflowsWorkflowsIndexLazyRouteImport = createFileRoute(
  '/app/admin/fsm-workflows/workflows/',
)()

const AppRoute = AppRouteImport.update({
  id: '/app',
  path: '/app',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/app.lazy').then((d) => d.Route))
const PublicRoute = PublicRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any).lazy(() => import('./routes/app/index.lazy').then((d) => d.Route))
const PublicIndexRoute = PublicIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PublicRoute,
} as any).lazy(() => import('./routes/_public.index.lazy').then((d) => d.Route))
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any).lazy(() => import('./routes/app/settings.lazy').then((d) => d.Route))
const AppCustomerRoute = AppCustomerRouteImport.update({
  id: '/$customer',
  path: '/$customer',
  getParentRoute: () => AppRoute,
} as any)
const PublicRepairRoute = PublicRepairRouteImport.update({
  id: '/repair',
  path: '/repair',
  getParentRoute: () => PublicRoute,
} as any).lazy(() =>
  import('./routes/_public.repair.lazy').then((d) => d.Route),
)
const PublicRegisterRoute = PublicRegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => PublicRoute,
} as any).lazy(() =>
  import('./routes/_public.register.lazy').then((d) => d.Route),
)
const PublicPrivacyRoute = PublicPrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => PublicRoute,
} as any).lazy(() =>
  import('./routes/_public.privacy.lazy').then((d) => d.Route),
)
const PublicLoginRoute = PublicLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => PublicRoute,
} as any).lazy(() => import('./routes/_public.login.lazy').then((d) => d.Route))
const PublicCompleteRegistrationRoute =
  PublicCompleteRegistrationRouteImport.update({
    id: '/complete-registration',
    path: '/complete-registration',
    getParentRoute: () => PublicRoute,
  } as any).lazy(() =>
    import('./routes/_public.complete-registration.lazy').then((d) => d.Route),
  )
const AppSettingsIndexRoute = AppSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSettingsRoute,
} as any).lazy(() =>
  import('./routes/app/settings.index.lazy').then((d) => d.Route),
)
const AppCustomerIndexRoute = AppCustomerIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppCustomerRoute,
} as any).lazy(() =>
  import('./routes/app/$customer/index.lazy').then((d) => d.Route),
)
const AppSettingsFsmWorkflowsRoute = AppSettingsFsmWorkflowsRouteImport.update({
  id: '/fsm-workflows',
  path: '/fsm-workflows',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsCustomersRoute = AppSettingsCustomersRouteImport.update({
  id: '/customers',
  path: '/customers',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppCCustomerSlugRoute = AppCCustomerSlugRouteImport.update({
  id: '/c/$customerSlug',
  path: '/c/$customerSlug',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminUsersRoute = AppAdminUsersRouteImport.update({
  id: '/admin/users',
  path: '/admin/users',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminStationsRoute = AppAdminStationsRouteImport.update({
  id: '/admin/stations',
  path: '/admin/stations',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminRolesRoute = AppAdminRolesRouteImport.update({
  id: '/admin/roles',
  path: '/admin/roles',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminNotificationChannelsRoute =
  AppAdminNotificationChannelsRouteImport.update({
    id: '/admin/notification-channels',
    path: '/admin/notification-channels',
    getParentRoute: () => AppRoute,
  } as any)
const AppAdminMaterialsRoute = AppAdminMaterialsRouteImport.update({
  id: '/admin/materials',
  path: '/admin/materials',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminMapRoute = AppAdminMapRouteImport.update({
  id: '/admin/map',
  path: '/admin/map',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminLocationsRoute = AppAdminLocationsRouteImport.update({
  id: '/admin/locations',
  path: '/admin/locations',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminKpisRoute = AppAdminKpisRouteImport.update({
  id: '/admin/kpis',
  path: '/admin/kpis',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminFsmWorkflowsRoute = AppAdminFsmWorkflowsRouteImport.update({
  id: '/admin/fsm-workflows',
  path: '/admin/fsm-workflows',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminFsmRoute = AppAdminFsmRouteImport.update({
  id: '/admin/fsm',
  path: '/admin/fsm',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminDevicesRoute = AppAdminDevicesRouteImport.update({
  id: '/admin/devices',
  path: '/admin/devices',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminCustomersRoute = AppAdminCustomersRouteImport.update({
  id: '/admin/customers',
  path: '/admin/customers',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminBikesRoute = AppAdminBikesRouteImport.update({
  id: '/admin/bikes',
  path: '/admin/bikes',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminBikeModelsRoute = AppAdminBikeModelsRouteImport.update({
  id: '/admin/bike-models',
  path: '/admin/bike-models',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsCustomersIndexRoute =
  AppSettingsCustomersIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppSettingsCustomersRoute,
  } as any).lazy(() =>
    import('./routes/app/settings/customers.index.lazy').then((d) => d.Route),
  )
const AppAdminUsersIndexRoute = AppAdminUsersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAdminUsersRoute,
} as any).lazy(() =>
  import('./routes/app/admin/users.index.lazy').then((d) => d.Route),
)
const AppAdminStationsIndexRoute = AppAdminStationsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAdminStationsRoute,
} as any).lazy(() =>
  import('./routes/app/admin/stations.index.lazy').then((d) => d.Route),
)
const AppAdminRolesIndexRoute = AppAdminRolesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAdminRolesRoute,
} as any).lazy(() =>
  import('./routes/app/admin/roles.index.lazy').then((d) => d.Route),
)
const AppAdminNotificationChannelsIndexRoute =
  AppAdminNotificationChannelsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppAdminNotificationChannelsRoute,
  } as any).lazy(() =>
    import('./routes/app/admin/notification-channels.index.lazy').then(
      (d) => d.Route,
    ),
  )
const AppAdminMaterialsIndexRoute = AppAdminMaterialsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAdminMaterialsRoute,
} as any).lazy(() =>
  import('./routes/app/admin/materials.index.lazy').then((d) => d.Route),
)
const AppAdminMapIndexRoute = AppAdminMapIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAdminMapRoute,
} as any).lazy(() =>
  import('./routes/app/admin/map.index.lazy').then((d) => d.Route),
)
const AppAdminLocationsIndexRoute = AppAdminLocationsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAdminLocationsRoute,
} as any).lazy(() =>
  import('./routes/app/admin/locations.index.lazy').then((d) => d.Route),
)
const AppAdminKpisIndexRoute = AppAdminKpisIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAdminKpisRoute,
} as any).lazy(() =>
  import('./routes/app/admin/kpis.index.lazy').then((d) => d.Route),
)
const AppAdminFsmIndexRoute = AppAdminFsmIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAdminFsmRoute,
} as any).lazy(() =>
  import('./routes/app/admin/fsm.index.lazy').then((d) => d.Route),
)
const AppAdminFsmWorkflowsIndexRoute =
  AppAdminFsmWorkflowsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppAdminFsmWorkflowsRoute,
  } as any).lazy(() =>
    import('./routes/app/admin/fsm-workflows.index.lazy').then((d) => d.Route),
  )
const AppAdminDevicesIndexRoute = AppAdminDevicesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAdminDevicesRoute,
} as any).lazy(() =>
  import('./routes/app/admin/devices.index.lazy').then((d) => d.Route),
)
const AppAdminCustomersIndexRoute = AppAdminCustomersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAdminCustomersRoute,
} as any).lazy(() =>
  import('./routes/app/admin/customers.index.lazy').then((d) => d.Route),
)
const AppAdminBikesIndexRoute = AppAdminBikesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAdminBikesRoute,
} as any).lazy(() =>
  import('./routes/app/admin/bikes.index.lazy').then((d) => d.Route),
)
const AppAdminBikeModelsIndexRoute = AppAdminBikeModelsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAdminBikeModelsRoute,
} as any).lazy(() =>
  import('./routes/app/admin/bike-models.index.lazy').then((d) => d.Route),
)
const AppCustomerRequestsIndexRoute =
  AppCustomerRequestsIndexRouteImport.update({
    id: '/requests/',
    path: '/requests/',
    getParentRoute: () => AppCustomerRoute,
  } as any)
const AppCCustomerSlugTrackingRoute =
  AppCCustomerSlugTrackingRouteImport.update({
    id: '/tracking',
    path: '/tracking',
    getParentRoute: () => AppCCustomerSlugRoute,
  } as any)
const AppCCustomerSlugMaterialsRoute =
  AppCCustomerSlugMaterialsRouteImport.update({
    id: '/materials',
    path: '/materials',
    getParentRoute: () => AppCCustomerSlugRoute,
  } as any)
const AppCCustomerSlugLocationsRoute =
  AppCCustomerSlugLocationsRouteImport.update({
    id: '/locations',
    path: '/locations',
    getParentRoute: () => AppCCustomerSlugRoute,
  } as any)
const AppCCustomerSlugBikesRoute = AppCCustomerSlugBikesRouteImport.update({
  id: '/bikes',
  path: '/bikes',
  getParentRoute: () => AppCCustomerSlugRoute,
} as any)
const AppCCustomerSlugBikeModelsRoute =
  AppCCustomerSlugBikeModelsRouteImport.update({
    id: '/bike-models',
    path: '/bike-models',
    getParentRoute: () => AppCCustomerSlugRoute,
  } as any)
const AppAdminUsersInviteRoute = AppAdminUsersInviteRouteImport.update({
  id: '/invite',
  path: '/invite',
  getParentRoute: () => AppAdminUsersRoute,
} as any).lazy(() =>
  import('./routes/app/admin/users.invite.lazy').then((d) => d.Route),
)
const AppAdminUsersIdRoute = AppAdminUsersIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AppAdminUsersRoute,
} as any).lazy(() =>
  import('./routes/app/admin/users.$id.lazy').then((d) => d.Route),
)
const AppAdminStationsNewRoute = AppAdminStationsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AppAdminStationsRoute,
} as any).lazy(() =>
  import('./routes/app/admin/stations.new.lazy').then((d) => d.Route),
)
const AppAdminStationsIdRoute = AppAdminStationsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AppAdminStationsRoute,
} as any).lazy(() =>
  import('./routes/app/admin/stations.$id.lazy').then((d) => d.Route),
)
const AppAdminRolesIdRoute = AppAdminRolesIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AppAdminRolesRoute,
} as any).lazy(() =>
  import('./routes/app/admin/roles.$id.lazy').then((d) => d.Route),
)
const AppAdminMaterialsNewRoute = AppAdminMaterialsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AppAdminMaterialsRoute,
} as any).lazy(() =>
  import('./routes/app/admin/materials.new.lazy').then((d) => d.Route),
)
const AppAdminMaterialsImportRelationsRoute =
  AppAdminMaterialsImportRelationsRouteImport.update({
    id: '/import-relations',
    path: '/import-relations',
    getParentRoute: () => AppAdminMaterialsRoute,
  } as any).lazy(() =>
    import('./routes/app/admin/materials.import-relations.lazy').then(
      (d) => d.Route,
    ),
  )
const AppAdminMaterialsImportRoute = AppAdminMaterialsImportRouteImport.update({
  id: '/import',
  path: '/import',
  getParentRoute: () => AppAdminMaterialsRoute,
} as any).lazy(() =>
  import('./routes/app/admin/materials.import.lazy').then((d) => d.Route),
)
const AppAdminMaterialsIdRoute = AppAdminMaterialsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AppAdminMaterialsRoute,
} as any)
const AppAdminLocationsNewRoute = AppAdminLocationsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AppAdminLocationsRoute,
} as any).lazy(() =>
  import('./routes/app/admin/locations.new.lazy').then((d) => d.Route),
)
const AppAdminLocationsIdRoute = AppAdminLocationsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AppAdminLocationsRoute,
} as any).lazy(() =>
  import('./routes/app/admin/locations.$id.lazy').then((d) => d.Route),
)
const AppAdminDevicesNewRoute = AppAdminDevicesNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AppAdminDevicesRoute,
} as any).lazy(() =>
  import('./routes/app/admin/devices.new.lazy').then((d) => d.Route),
)
const AppAdminDevicesIdRoute = AppAdminDevicesIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AppAdminDevicesRoute,
} as any).lazy(() =>
  import('./routes/app/admin/devices.$id.lazy').then((d) => d.Route),
)
const AppAdminBikesNewRoute = AppAdminBikesNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AppAdminBikesRoute,
} as any).lazy(() =>
  import('./routes/app/admin/bikes.new.lazy').then((d) => d.Route),
)
const AppAdminBikesIdRoute = AppAdminBikesIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AppAdminBikesRoute,
} as any).lazy(() =>
  import('./routes/app/admin/bikes.$id.lazy').then((d) => d.Route),
)
const AppAdminBikeModelsNewRoute = AppAdminBikeModelsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AppAdminBikeModelsRoute,
} as any).lazy(() =>
  import('./routes/app/admin/bike-models.new.lazy').then((d) => d.Route),
)
const AppAdminBikeModelsIdRoute = AppAdminBikeModelsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AppAdminBikeModelsRoute,
} as any)
const AppCustomerRequestsNewRoute = AppCustomerRequestsNewRouteImport.update({
  id: '/requests/new',
  path: '/requests/new',
  getParentRoute: () => AppCustomerRoute,
} as any)
const AppCustomerRequestsIdRoute = AppCustomerRequestsIdRouteImport.update({
  id: '/requests/$id',
  path: '/requests/$id',
  getParentRoute: () => AppCustomerRoute,
} as any)
const AppAdminFsmWorkflowsIndexLazyRoute =
  AppAdminFsmWorkflowsIndexLazyRouteImport.update({
    id: '/workflows/',
    path: '/workflows/',
    getParentRoute: () => AppAdminFsmRoute,
  } as any).lazy(() =>
    import('./routes/app/admin/fsm.workflows.index.lazy').then((d) => d.Route),
  )
const AppAdminFsmWorkflowsWorkflowsIndexLazyRoute =
  AppAdminFsmWorkflowsWorkflowsIndexLazyRouteImport.update({
    id: '/workflows/',
    path: '/workflows/',
    getParentRoute: () => AppAdminFsmWorkflowsRoute,
  } as any).lazy(() =>
    import('./routes/app/admin/fsm-workflows.workflows.index.lazy').then(
      (d) => d.Route,
    ),
  )
const AppCCustomerSlugTrackingIndexRoute =
  AppCCustomerSlugTrackingIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppCCustomerSlugTrackingRoute,
  } as any).lazy(() =>
    import('./routes/app/c.$customerSlug/tracking.index.lazy').then(
      (d) => d.Route,
    ),
  )
const AppCCustomerSlugRequestsIndexRoute =
  AppCCustomerSlugRequestsIndexRouteImport.update({
    id: '/requests/',
    path: '/requests/',
    getParentRoute: () => AppCCustomerSlugRoute,
  } as any).lazy(() =>
    import('./routes/app/c.$customerSlug/requests.index.lazy').then(
      (d) => d.Route,
    ),
  )
const AppCCustomerSlugMaterialsIndexRoute =
  AppCCustomerSlugMaterialsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppCCustomerSlugMaterialsRoute,
  } as any).lazy(() =>
    import('./routes/app/c.$customerSlug/materials.index.lazy').then(
      (d) => d.Route,
    ),
  )
const AppCCustomerSlugLocationsIndexRoute =
  AppCCustomerSlugLocationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppCCustomerSlugLocationsRoute,
  } as any).lazy(() =>
    import('./routes/app/c.$customerSlug/locations.index.lazy').then(
      (d) => d.Route,
    ),
  )
const AppCCustomerSlugBikesIndexRoute =
  AppCCustomerSlugBikesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppCCustomerSlugBikesRoute,
  } as any).lazy(() =>
    import('./routes/app/c.$customerSlug/bikes.index.lazy').then(
      (d) => d.Route,
    ),
  )
const AppCCustomerSlugBikeModelsIndexRoute =
  AppCCustomerSlugBikeModelsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppCCustomerSlugBikeModelsRoute,
  } as any).lazy(() =>
    import('./routes/app/c.$customerSlug/bike-models.index.lazy').then(
      (d) => d.Route,
    ),
  )
const AppAdminMaterialsIdIndexRoute =
  AppAdminMaterialsIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppAdminMaterialsIdRoute,
  } as any).lazy(() =>
    import('./routes/app/admin/materials.$id.index.lazy').then((d) => d.Route),
  )
const AppAdminFsmTransitionsIndexRoute =
  AppAdminFsmTransitionsIndexRouteImport.update({
    id: '/transitions/',
    path: '/transitions/',
    getParentRoute: () => AppAdminFsmRoute,
  } as any).lazy(() =>
    import('./routes/app/admin/fsm.transitions.index.lazy').then(
      (d) => d.Route,
    ),
  )
const AppAdminFsmStatesIndexRoute = AppAdminFsmStatesIndexRouteImport.update({
  id: '/states/',
  path: '/states/',
  getParentRoute: () => AppAdminFsmRoute,
} as any).lazy(() =>
  import('./routes/app/admin/fsm.states.index.lazy').then((d) => d.Route),
)
const AppAdminFsmEntityTypesIndexRoute =
  AppAdminFsmEntityTypesIndexRouteImport.update({
    id: '/entity-types/',
    path: '/entity-types/',
    getParentRoute: () => AppAdminFsmRoute,
  } as any).lazy(() =>
    import('./routes/app/admin/fsm.entity-types.index.lazy').then(
      (d) => d.Route,
    ),
  )
const AppAdminFsmEntitiesIndexRoute =
  AppAdminFsmEntitiesIndexRouteImport.update({
    id: '/entities/',
    path: '/entities/',
    getParentRoute: () => AppAdminFsmRoute,
  } as any).lazy(() =>
    import('./routes/app/admin/fsm.entities.index.lazy').then((d) => d.Route),
  )
const AppAdminFsmDocumentTypesIndexRoute =
  AppAdminFsmDocumentTypesIndexRouteImport.update({
    id: '/document-types/',
    path: '/document-types/',
    getParentRoute: () => AppAdminFsmRoute,
  } as any).lazy(() =>
    import('./routes/app/admin/fsm.document-types.index.lazy').then(
      (d) => d.Route,
    ),
  )
const AppAdminFsmWorkflowsTransitionsIndexRoute =
  AppAdminFsmWorkflowsTransitionsIndexRouteImport.update({
    id: '/transitions/',
    path: '/transitions/',
    getParentRoute: () => AppAdminFsmWorkflowsRoute,
  } as any).lazy(() =>
    import('./routes/app/admin/fsm-workflows.transitions.index.lazy').then(
      (d) => d.Route,
    ),
  )
const AppAdminFsmWorkflowsStatesIndexRoute =
  AppAdminFsmWorkflowsStatesIndexRouteImport.update({
    id: '/states/',
    path: '/states/',
    getParentRoute: () => AppAdminFsmWorkflowsRoute,
  } as any).lazy(() =>
    import('./routes/app/admin/fsm-workflows.states.index.lazy').then(
      (d) => d.Route,
    ),
  )
const AppAdminFsmWorkflowsEntityTypesIndexRoute =
  AppAdminFsmWorkflowsEntityTypesIndexRouteImport.update({
    id: '/entity-types/',
    path: '/entity-types/',
    getParentRoute: () => AppAdminFsmWorkflowsRoute,
  } as any).lazy(() =>
    import('./routes/app/admin/fsm-workflows.entity-types.index.lazy').then(
      (d) => d.Route,
    ),
  )
const AppAdminFsmWorkflowsEntitiesIndexRoute =
  AppAdminFsmWorkflowsEntitiesIndexRouteImport.update({
    id: '/entities/',
    path: '/entities/',
    getParentRoute: () => AppAdminFsmWorkflowsRoute,
  } as any).lazy(() =>
    import('./routes/app/admin/fsm-workflows.entities.index.lazy').then(
      (d) => d.Route,
    ),
  )
const AppAdminFsmWorkflowsDocumentTypesIndexRoute =
  AppAdminFsmWorkflowsDocumentTypesIndexRouteImport.update({
    id: '/document-types/',
    path: '/document-types/',
    getParentRoute: () => AppAdminFsmWorkflowsRoute,
  } as any).lazy(() =>
    import('./routes/app/admin/fsm-workflows.document-types.index.lazy').then(
      (d) => d.Route,
    ),
  )
const AppAdminBikeModelsIdIndexRoute =
  AppAdminBikeModelsIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppAdminBikeModelsIdRoute,
  } as any).lazy(() =>
    import('./routes/app/admin/bike-models.$id.index.lazy').then(
      (d) => d.Route,
    ),
  )
const AppCCustomerSlugRequestsNewRoute =
  AppCCustomerSlugRequestsNewRouteImport.update({
    id: '/requests/new',
    path: '/requests/new',
    getParentRoute: () => AppCCustomerSlugRoute,
  } as any).lazy(() =>
    import('./routes/app/c.$customerSlug/requests.new.lazy').then(
      (d) => d.Route,
    ),
  )
const AppCCustomerSlugRequestsIdRoute =
  AppCCustomerSlugRequestsIdRouteImport.update({
    id: '/requests/$id',
    path: '/requests/$id',
    getParentRoute: () => AppCCustomerSlugRoute,
  } as any).lazy(() =>
    import('./routes/app/c.$customerSlug/requests.$id.lazy').then(
      (d) => d.Route,
    ),
  )
const AppCCustomerSlugReportingMaterialsBudgetRoute =
  AppCCustomerSlugReportingMaterialsBudgetRouteImport.update({
    id: '/reporting/materials-budget',
    path: '/reporting/materials-budget',
    getParentRoute: () => AppCCustomerSlugRoute,
  } as any)
const AppCCustomerSlugReportingKpiOpsRoute =
  AppCCustomerSlugReportingKpiOpsRouteImport.update({
    id: '/reporting/kpi-ops',
    path: '/reporting/kpi-ops',
    getParentRoute: () => AppCCustomerSlugRoute,
  } as any)
const AppCCustomerSlugMaterialsNewRoute =
  AppCCustomerSlugMaterialsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AppCCustomerSlugMaterialsRoute,
  } as any).lazy(() =>
    import('./routes/app/c.$customerSlug/materials.new.lazy').then(
      (d) => d.Route,
    ),
  )
const AppCCustomerSlugMaterialsImportRelationsRoute =
  AppCCustomerSlugMaterialsImportRelationsRouteImport.update({
    id: '/import-relations',
    path: '/import-relations',
    getParentRoute: () => AppCCustomerSlugMaterialsRoute,
  } as any).lazy(() =>
    import('./routes/app/c.$customerSlug/materials.import-relations.lazy').then(
      (d) => d.Route,
    ),
  )
const AppCCustomerSlugMaterialsImportRoute =
  AppCCustomerSlugMaterialsImportRouteImport.update({
    id: '/import',
    path: '/import',
    getParentRoute: () => AppCCustomerSlugMaterialsRoute,
  } as any).lazy(() =>
    import('./routes/app/c.$customerSlug/materials.import.lazy').then(
      (d) => d.Route,
    ),
  )
const AppCCustomerSlugMaterialsIdRoute =
  AppCCustomerSlugMaterialsIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AppCCustomerSlugMaterialsRoute,
  } as any)
const AppCCustomerSlugLocationsNewRoute =
  AppCCustomerSlugLocationsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AppCCustomerSlugLocationsRoute,
  } as any).lazy(() =>
    import('./routes/app/c.$customerSlug/locations.new.lazy').then(
      (d) => d.Route,
    ),
  )
const AppCCustomerSlugLocationsIdRoute =
  AppCCustomerSlugLocationsIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AppCCustomerSlugLocationsRoute,
  } as any).lazy(() =>
    import('./routes/app/c.$customerSlug/locations.$id.lazy').then(
      (d) => d.Route,
    ),
  )
const AppCCustomerSlugDDocTypeSlugRoute =
  AppCCustomerSlugDDocTypeSlugRouteImport.update({
    id: '/d/$docTypeSlug',
    path: '/d/$docTypeSlug',
    getParentRoute: () => AppCCustomerSlugRoute,
  } as any)
const AppCCustomerSlugBikesNewRoute =
  AppCCustomerSlugBikesNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AppCCustomerSlugBikesRoute,
  } as any).lazy(() =>
    import('./routes/app/c.$customerSlug/bikes.new.lazy').then((d) => d.Route),
  )
const AppCCustomerSlugBikesIdRoute = AppCCustomerSlugBikesIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AppCCustomerSlugBikesRoute,
} as any).lazy(() =>
  import('./routes/app/c.$customerSlug/bikes.$id.lazy').then((d) => d.Route),
)
const AppCCustomerSlugBikeModelsNewRoute =
  AppCCustomerSlugBikeModelsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AppCCustomerSlugBikeModelsRoute,
  } as any).lazy(() =>
    import('./routes/app/c.$customerSlug/bike-models.new.lazy').then(
      (d) => d.Route,
    ),
  )
const AppCCustomerSlugBikeModelsIdRoute =
  AppCCustomerSlugBikeModelsIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AppCCustomerSlugBikeModelsRoute,
  } as any)
const AppAdminMaterialsIdBikeModelsRoute =
  AppAdminMaterialsIdBikeModelsRouteImport.update({
    id: '/bike-models',
    path: '/bike-models',
    getParentRoute: () => AppAdminMaterialsIdRoute,
  } as any).lazy(() =>
    import('./routes/app/admin/materials.$id.bike-models.lazy').then(
      (d) => d.Route,
    ),
  )
const AppAdminFsmTransitionsIdRoute =
  AppAdminFsmTransitionsIdRouteImport.update({
    id: '/transitions/$id',
    path: '/transitions/$id',
    getParentRoute: () => AppAdminFsmRoute,
  } as any).lazy(() =>
    import('./routes/app/admin/fsm.transitions.$id.lazy').then((d) => d.Route),
  )
const AppAdminFsmStatesIdRoute = AppAdminFsmStatesIdRouteImport.update({
  id: '/states/$id',
  path: '/states/$id',
  getParentRoute: () => AppAdminFsmRoute,
} as any).lazy(() =>
  import('./routes/app/admin/fsm.states.$id.lazy').then((d) => d.Route),
)
const AppAdminFsmEntityTypesIdRoute =
  AppAdminFsmEntityTypesIdRouteImport.update({
    id: '/entity-types/$id',
    path: '/entity-types/$id',
    getParentRoute: () => AppAdminFsmRoute,
  } as any).lazy(() =>
    import('./routes/app/admin/fsm.entity-types.$id.lazy').then((d) => d.Route),
  )
const AppAdminFsmEntitiesIdRoute = AppAdminFsmEntitiesIdRouteImport.update({
  id: '/entities/$id',
  path: '/entities/$id',
  getParentRoute: () => AppAdminFsmRoute,
} as any).lazy(() =>
  import('./routes/app/admin/fsm.entities.$id.lazy').then((d) => d.Route),
)
const AppAdminFsmDocumentTypesIdRoute =
  AppAdminFsmDocumentTypesIdRouteImport.update({
    id: '/document-types/$id',
    path: '/document-types/$id',
    getParentRoute: () => AppAdminFsmRoute,
  } as any).lazy(() =>
    import('./routes/app/admin/fsm.document-types.$id.lazy').then(
      (d) => d.Route,
    ),
  )
const AppAdminFsmWorkflowsTransitionsIdRoute =
  AppAdminFsmWorkflowsTransitionsIdRouteImport.update({
    id: '/transitions/$id',
    path: '/transitions/$id',
    getParentRoute: () => AppAdminFsmWorkflowsRoute,
  } as any).lazy(() =>
    import('./routes/app/admin/fsm-workflows.transitions.$id.lazy').then(
      (d) => d.Route,
    ),
  )
const AppAdminFsmWorkflowsStatesIdRoute =
  AppAdminFsmWorkflowsStatesIdRouteImport.update({
    id: '/states/$id',
    path: '/states/$id',
    getParentRoute: () => AppAdminFsmWorkflowsRoute,
  } as any).lazy(() =>
    import('./routes/app/admin/fsm-workflows.states.$id.lazy').then(
      (d) => d.Route,
    ),
  )
const AppAdminFsmWorkflowsEntityTypesIdRoute =
  AppAdminFsmWorkflowsEntityTypesIdRouteImport.update({
    id: '/entity-types/$id',
    path: '/entity-types/$id',
    getParentRoute: () => AppAdminFsmWorkflowsRoute,
  } as any).lazy(() =>
    import('./routes/app/admin/fsm-workflows.entity-types.$id.lazy').then(
      (d) => d.Route,
    ),
  )
const AppAdminFsmWorkflowsEntitiesIdRoute =
  AppAdminFsmWorkflowsEntitiesIdRouteImport.update({
    id: '/entities/$id',
    path: '/entities/$id',
    getParentRoute: () => AppAdminFsmWorkflowsRoute,
  } as any).lazy(() =>
    import('./routes/app/admin/fsm-workflows.entities.$id.lazy').then(
      (d) => d.Route,
    ),
  )
const AppAdminFsmWorkflowsDocumentTypesIdRoute =
  AppAdminFsmWorkflowsDocumentTypesIdRouteImport.update({
    id: '/document-types/$id',
    path: '/document-types/$id',
    getParentRoute: () => AppAdminFsmWorkflowsRoute,
  } as any).lazy(() =>
    import('./routes/app/admin/fsm-workflows.document-types.$id.lazy').then(
      (d) => d.Route,
    ),
  )
const AppAdminBikeModelsIdMaterialsRoute =
  AppAdminBikeModelsIdMaterialsRouteImport.update({
    id: '/materials',
    path: '/materials',
    getParentRoute: () => AppAdminBikeModelsIdRoute,
  } as any).lazy(() =>
    import('./routes/app/admin/bike-models.$id.materials.lazy').then(
      (d) => d.Route,
    ),
  )
const AppCCustomerSlugReportingMaterialsBudgetIndexRoute =
  AppCCustomerSlugReportingMaterialsBudgetIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppCCustomerSlugReportingMaterialsBudgetRoute,
  } as any).lazy(() =>
    import('./routes/app/c.$customerSlug/reporting.materials-budget.index.lazy').then(
      (d) => d.Route,
    ),
  )
const AppCCustomerSlugReportingKpiOpsIndexRoute =
  AppCCustomerSlugReportingKpiOpsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppCCustomerSlugReportingKpiOpsRoute,
  } as any).lazy(() =>
    import('./routes/app/c.$customerSlug/reporting.kpi-ops.index.lazy').then(
      (d) => d.Route,
    ),
  )
const AppCCustomerSlugMaterialsIdIndexRoute =
  AppCCustomerSlugMaterialsIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppCCustomerSlugMaterialsIdRoute,
  } as any).lazy(() =>
    import('./routes/app/c.$customerSlug/materials.$id.index.lazy').then(
      (d) => d.Route,
    ),
  )
const AppCCustomerSlugDDocTypeSlugIndexRoute =
  AppCCustomerSlugDDocTypeSlugIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppCCustomerSlugDDocTypeSlugRoute,
  } as any).lazy(() =>
    import('./routes/app/c.$customerSlug/d.$docTypeSlug.index.lazy').then(
      (d) => d.Route,
    ),
  )
const AppCCustomerSlugBikeModelsIdIndexRoute =
  AppCCustomerSlugBikeModelsIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppCCustomerSlugBikeModelsIdRoute,
  } as any).lazy(() =>
    import('./routes/app/c.$customerSlug/bike-models.$id.index.lazy').then(
      (d) => d.Route,
    ),
  )
const AppCCustomerSlugMaterialsIdBikeModelsRoute =
  AppCCustomerSlugMaterialsIdBikeModelsRouteImport.update({
    id: '/bike-models',
    path: '/bike-models',
    getParentRoute: () => AppCCustomerSlugMaterialsIdRoute,
  } as any).lazy(() =>
    import('./routes/app/c.$customerSlug/materials.$id.bike-models.lazy').then(
      (d) => d.Route,
    ),
  )
const AppCCustomerSlugDDocTypeSlugDocumentIdRoute =
  AppCCustomerSlugDDocTypeSlugDocumentIdRouteImport.update({
    id: '/$documentId',
    path: '/$documentId',
    getParentRoute: () => AppCCustomerSlugDDocTypeSlugRoute,
  } as any).lazy(() =>
    import('./routes/app/c.$customerSlug/d.$docTypeSlug.$documentId.lazy').then(
      (d) => d.Route,
    ),
  )
const AppCCustomerSlugBikeModelsIdMaterialsRoute =
  AppCCustomerSlugBikeModelsIdMaterialsRouteImport.update({
    id: '/materials',
    path: '/materials',
    getParentRoute: () => AppCCustomerSlugBikeModelsIdRoute,
  } as any).lazy(() =>
    import('./routes/app/c.$customerSlug/bike-models.$id.materials.lazy').then(
      (d) => d.Route,
    ),
  )

export interface FileRoutesByFullPath {
  '/': typeof PublicIndexRoute
  '/app': typeof AppRouteWithChildren
  '/complete-registration': typeof PublicCompleteRegistrationRoute
  '/login': typeof PublicLoginRoute
  '/privacy': typeof PublicPrivacyRoute
  '/register': typeof PublicRegisterRoute
  '/repair': typeof PublicRepairRoute
  '/app/$customer': typeof AppCustomerRouteWithChildren
  '/app/settings': typeof AppSettingsRouteWithChildren
  '/app/': typeof AppIndexRoute
  '/app/admin/bike-models': typeof AppAdminBikeModelsRouteWithChildren
  '/app/admin/bikes': typeof AppAdminBikesRouteWithChildren
  '/app/admin/customers': typeof AppAdminCustomersRouteWithChildren
  '/app/admin/devices': typeof AppAdminDevicesRouteWithChildren
  '/app/admin/fsm': typeof AppAdminFsmRouteWithChildren
  '/app/admin/fsm-workflows': typeof AppAdminFsmWorkflowsRouteWithChildren
  '/app/admin/kpis': typeof AppAdminKpisRouteWithChildren
  '/app/admin/locations': typeof AppAdminLocationsRouteWithChildren
  '/app/admin/map': typeof AppAdminMapRouteWithChildren
  '/app/admin/materials': typeof AppAdminMaterialsRouteWithChildren
  '/app/admin/notification-channels': typeof AppAdminNotificationChannelsRouteWithChildren
  '/app/admin/roles': typeof AppAdminRolesRouteWithChildren
  '/app/admin/stations': typeof AppAdminStationsRouteWithChildren
  '/app/admin/users': typeof AppAdminUsersRouteWithChildren
  '/app/c/$customerSlug': typeof AppCCustomerSlugRouteWithChildren
  '/app/settings/customers': typeof AppSettingsCustomersRouteWithChildren
  '/app/settings/fsm-workflows': typeof AppSettingsFsmWorkflowsRoute
  '/app/$customer/': typeof AppCustomerIndexRoute
  '/app/settings/': typeof AppSettingsIndexRoute
  '/app/$customer/requests/$id': typeof AppCustomerRequestsIdRoute
  '/app/$customer/requests/new': typeof AppCustomerRequestsNewRoute
  '/app/admin/bike-models/$id': typeof AppAdminBikeModelsIdRouteWithChildren
  '/app/admin/bike-models/new': typeof AppAdminBikeModelsNewRoute
  '/app/admin/bikes/$id': typeof AppAdminBikesIdRoute
  '/app/admin/bikes/new': typeof AppAdminBikesNewRoute
  '/app/admin/devices/$id': typeof AppAdminDevicesIdRoute
  '/app/admin/devices/new': typeof AppAdminDevicesNewRoute
  '/app/admin/locations/$id': typeof AppAdminLocationsIdRoute
  '/app/admin/locations/new': typeof AppAdminLocationsNewRoute
  '/app/admin/materials/$id': typeof AppAdminMaterialsIdRouteWithChildren
  '/app/admin/materials/import': typeof AppAdminMaterialsImportRoute
  '/app/admin/materials/import-relations': typeof AppAdminMaterialsImportRelationsRoute
  '/app/admin/materials/new': typeof AppAdminMaterialsNewRoute
  '/app/admin/roles/$id': typeof AppAdminRolesIdRoute
  '/app/admin/stations/$id': typeof AppAdminStationsIdRoute
  '/app/admin/stations/new': typeof AppAdminStationsNewRoute
  '/app/admin/users/$id': typeof AppAdminUsersIdRoute
  '/app/admin/users/invite': typeof AppAdminUsersInviteRoute
  '/app/c/$customerSlug/bike-models': typeof AppCCustomerSlugBikeModelsRouteWithChildren
  '/app/c/$customerSlug/bikes': typeof AppCCustomerSlugBikesRouteWithChildren
  '/app/c/$customerSlug/locations': typeof AppCCustomerSlugLocationsRouteWithChildren
  '/app/c/$customerSlug/materials': typeof AppCCustomerSlugMaterialsRouteWithChildren
  '/app/c/$customerSlug/tracking': typeof AppCCustomerSlugTrackingRouteWithChildren
  '/app/$customer/requests/': typeof AppCustomerRequestsIndexRoute
  '/app/admin/bike-models/': typeof AppAdminBikeModelsIndexRoute
  '/app/admin/bikes/': typeof AppAdminBikesIndexRoute
  '/app/admin/customers/': typeof AppAdminCustomersIndexRoute
  '/app/admin/devices/': typeof AppAdminDevicesIndexRoute
  '/app/admin/fsm-workflows/': typeof AppAdminFsmWorkflowsIndexRoute
  '/app/admin/fsm/': typeof AppAdminFsmIndexRoute
  '/app/admin/kpis/': typeof AppAdminKpisIndexRoute
  '/app/admin/locations/': typeof AppAdminLocationsIndexRoute
  '/app/admin/map/': typeof AppAdminMapIndexRoute
  '/app/admin/materials/': typeof AppAdminMaterialsIndexRoute
  '/app/admin/notification-channels/': typeof AppAdminNotificationChannelsIndexRoute
  '/app/admin/roles/': typeof AppAdminRolesIndexRoute
  '/app/admin/stations/': typeof AppAdminStationsIndexRoute
  '/app/admin/users/': typeof AppAdminUsersIndexRoute
  '/app/settings/customers/': typeof AppSettingsCustomersIndexRoute
  '/app/admin/bike-models/$id/materials': typeof AppAdminBikeModelsIdMaterialsRoute
  '/app/admin/fsm-workflows/document-types/$id': typeof AppAdminFsmWorkflowsDocumentTypesIdRoute
  '/app/admin/fsm-workflows/entities/$id': typeof AppAdminFsmWorkflowsEntitiesIdRoute
  '/app/admin/fsm-workflows/entity-types/$id': typeof AppAdminFsmWorkflowsEntityTypesIdRoute
  '/app/admin/fsm-workflows/states/$id': typeof AppAdminFsmWorkflowsStatesIdRoute
  '/app/admin/fsm-workflows/transitions/$id': typeof AppAdminFsmWorkflowsTransitionsIdRoute
  '/app/admin/fsm/document-types/$id': typeof AppAdminFsmDocumentTypesIdRoute
  '/app/admin/fsm/entities/$id': typeof AppAdminFsmEntitiesIdRoute
  '/app/admin/fsm/entity-types/$id': typeof AppAdminFsmEntityTypesIdRoute
  '/app/admin/fsm/states/$id': typeof AppAdminFsmStatesIdRoute
  '/app/admin/fsm/transitions/$id': typeof AppAdminFsmTransitionsIdRoute
  '/app/admin/materials/$id/bike-models': typeof AppAdminMaterialsIdBikeModelsRoute
  '/app/c/$customerSlug/bike-models/$id': typeof AppCCustomerSlugBikeModelsIdRouteWithChildren
  '/app/c/$customerSlug/bike-models/new': typeof AppCCustomerSlugBikeModelsNewRoute
  '/app/c/$customerSlug/bikes/$id': typeof AppCCustomerSlugBikesIdRoute
  '/app/c/$customerSlug/bikes/new': typeof AppCCustomerSlugBikesNewRoute
  '/app/c/$customerSlug/d/$docTypeSlug': typeof AppCCustomerSlugDDocTypeSlugRouteWithChildren
  '/app/c/$customerSlug/locations/$id': typeof AppCCustomerSlugLocationsIdRoute
  '/app/c/$customerSlug/locations/new': typeof AppCCustomerSlugLocationsNewRoute
  '/app/c/$customerSlug/materials/$id': typeof AppCCustomerSlugMaterialsIdRouteWithChildren
  '/app/c/$customerSlug/materials/import': typeof AppCCustomerSlugMaterialsImportRoute
  '/app/c/$customerSlug/materials/import-relations': typeof AppCCustomerSlugMaterialsImportRelationsRoute
  '/app/c/$customerSlug/materials/new': typeof AppCCustomerSlugMaterialsNewRoute
  '/app/c/$customerSlug/reporting/kpi-ops': typeof AppCCustomerSlugReportingKpiOpsRouteWithChildren
  '/app/c/$customerSlug/reporting/materials-budget': typeof AppCCustomerSlugReportingMaterialsBudgetRouteWithChildren
  '/app/c/$customerSlug/requests/$id': typeof AppCCustomerSlugRequestsIdRoute
  '/app/c/$customerSlug/requests/new': typeof AppCCustomerSlugRequestsNewRoute
  '/app/admin/bike-models/$id/': typeof AppAdminBikeModelsIdIndexRoute
  '/app/admin/fsm-workflows/document-types/': typeof AppAdminFsmWorkflowsDocumentTypesIndexRoute
  '/app/admin/fsm-workflows/entities/': typeof AppAdminFsmWorkflowsEntitiesIndexRoute
  '/app/admin/fsm-workflows/entity-types/': typeof AppAdminFsmWorkflowsEntityTypesIndexRoute
  '/app/admin/fsm-workflows/states/': typeof AppAdminFsmWorkflowsStatesIndexRoute
  '/app/admin/fsm-workflows/transitions/': typeof AppAdminFsmWorkflowsTransitionsIndexRoute
  '/app/admin/fsm/document-types/': typeof AppAdminFsmDocumentTypesIndexRoute
  '/app/admin/fsm/entities/': typeof AppAdminFsmEntitiesIndexRoute
  '/app/admin/fsm/entity-types/': typeof AppAdminFsmEntityTypesIndexRoute
  '/app/admin/fsm/states/': typeof AppAdminFsmStatesIndexRoute
  '/app/admin/fsm/transitions/': typeof AppAdminFsmTransitionsIndexRoute
  '/app/admin/materials/$id/': typeof AppAdminMaterialsIdIndexRoute
  '/app/c/$customerSlug/bike-models/': typeof AppCCustomerSlugBikeModelsIndexRoute
  '/app/c/$customerSlug/bikes/': typeof AppCCustomerSlugBikesIndexRoute
  '/app/c/$customerSlug/locations/': typeof AppCCustomerSlugLocationsIndexRoute
  '/app/c/$customerSlug/materials/': typeof AppCCustomerSlugMaterialsIndexRoute
  '/app/c/$customerSlug/requests/': typeof AppCCustomerSlugRequestsIndexRoute
  '/app/c/$customerSlug/tracking/': typeof AppCCustomerSlugTrackingIndexRoute
  '/app/admin/fsm-workflows/workflows/': typeof AppAdminFsmWorkflowsWorkflowsIndexLazyRoute
  '/app/admin/fsm/workflows/': typeof AppAdminFsmWorkflowsIndexLazyRoute
  '/app/c/$customerSlug/bike-models/$id/materials': typeof AppCCustomerSlugBikeModelsIdMaterialsRoute
  '/app/c/$customerSlug/d/$docTypeSlug/$documentId': typeof AppCCustomerSlugDDocTypeSlugDocumentIdRoute
  '/app/c/$customerSlug/materials/$id/bike-models': typeof AppCCustomerSlugMaterialsIdBikeModelsRoute
  '/app/c/$customerSlug/bike-models/$id/': typeof AppCCustomerSlugBikeModelsIdIndexRoute
  '/app/c/$customerSlug/d/$docTypeSlug/': typeof AppCCustomerSlugDDocTypeSlugIndexRoute
  '/app/c/$customerSlug/materials/$id/': typeof AppCCustomerSlugMaterialsIdIndexRoute
  '/app/c/$customerSlug/reporting/kpi-ops/': typeof AppCCustomerSlugReportingKpiOpsIndexRoute
  '/app/c/$customerSlug/reporting/materials-budget/': typeof AppCCustomerSlugReportingMaterialsBudgetIndexRoute
}
export interface FileRoutesByTo {
  '/complete-registration': typeof PublicCompleteRegistrationRoute
  '/login': typeof PublicLoginRoute
  '/privacy': typeof PublicPrivacyRoute
  '/register': typeof PublicRegisterRoute
  '/repair': typeof PublicRepairRoute
  '/': typeof PublicIndexRoute
  '/app': typeof AppIndexRoute
  '/app/c/$customerSlug': typeof AppCCustomerSlugRouteWithChildren
  '/app/settings/fsm-workflows': typeof AppSettingsFsmWorkflowsRoute
  '/app/$customer': typeof AppCustomerIndexRoute
  '/app/settings': typeof AppSettingsIndexRoute
  '/app/$customer/requests/$id': typeof AppCustomerRequestsIdRoute
  '/app/$customer/requests/new': typeof AppCustomerRequestsNewRoute
  '/app/admin/bike-models/new': typeof AppAdminBikeModelsNewRoute
  '/app/admin/bikes/$id': typeof AppAdminBikesIdRoute
  '/app/admin/bikes/new': typeof AppAdminBikesNewRoute
  '/app/admin/devices/$id': typeof AppAdminDevicesIdRoute
  '/app/admin/devices/new': typeof AppAdminDevicesNewRoute
  '/app/admin/locations/$id': typeof AppAdminLocationsIdRoute
  '/app/admin/locations/new': typeof AppAdminLocationsNewRoute
  '/app/admin/materials/import': typeof AppAdminMaterialsImportRoute
  '/app/admin/materials/import-relations': typeof AppAdminMaterialsImportRelationsRoute
  '/app/admin/materials/new': typeof AppAdminMaterialsNewRoute
  '/app/admin/roles/$id': typeof AppAdminRolesIdRoute
  '/app/admin/stations/$id': typeof AppAdminStationsIdRoute
  '/app/admin/stations/new': typeof AppAdminStationsNewRoute
  '/app/admin/users/$id': typeof AppAdminUsersIdRoute
  '/app/admin/users/invite': typeof AppAdminUsersInviteRoute
  '/app/$customer/requests': typeof AppCustomerRequestsIndexRoute
  '/app/admin/bike-models': typeof AppAdminBikeModelsIndexRoute
  '/app/admin/bikes': typeof AppAdminBikesIndexRoute
  '/app/admin/customers': typeof AppAdminCustomersIndexRoute
  '/app/admin/devices': typeof AppAdminDevicesIndexRoute
  '/app/admin/fsm-workflows': typeof AppAdminFsmWorkflowsIndexRoute
  '/app/admin/fsm': typeof AppAdminFsmIndexRoute
  '/app/admin/kpis': typeof AppAdminKpisIndexRoute
  '/app/admin/locations': typeof AppAdminLocationsIndexRoute
  '/app/admin/map': typeof AppAdminMapIndexRoute
  '/app/admin/materials': typeof AppAdminMaterialsIndexRoute
  '/app/admin/notification-channels': typeof AppAdminNotificationChannelsIndexRoute
  '/app/admin/roles': typeof AppAdminRolesIndexRoute
  '/app/admin/stations': typeof AppAdminStationsIndexRoute
  '/app/admin/users': typeof AppAdminUsersIndexRoute
  '/app/settings/customers': typeof AppSettingsCustomersIndexRoute
  '/app/admin/bike-models/$id/materials': typeof AppAdminBikeModelsIdMaterialsRoute
  '/app/admin/fsm-workflows/document-types/$id': typeof AppAdminFsmWorkflowsDocumentTypesIdRoute
  '/app/admin/fsm-workflows/entities/$id': typeof AppAdminFsmWorkflowsEntitiesIdRoute
  '/app/admin/fsm-workflows/entity-types/$id': typeof AppAdminFsmWorkflowsEntityTypesIdRoute
  '/app/admin/fsm-workflows/states/$id': typeof AppAdminFsmWorkflowsStatesIdRoute
  '/app/admin/fsm-workflows/transitions/$id': typeof AppAdminFsmWorkflowsTransitionsIdRoute
  '/app/admin/fsm/document-types/$id': typeof AppAdminFsmDocumentTypesIdRoute
  '/app/admin/fsm/entities/$id': typeof AppAdminFsmEntitiesIdRoute
  '/app/admin/fsm/entity-types/$id': typeof AppAdminFsmEntityTypesIdRoute
  '/app/admin/fsm/states/$id': typeof AppAdminFsmStatesIdRoute
  '/app/admin/fsm/transitions/$id': typeof AppAdminFsmTransitionsIdRoute
  '/app/admin/materials/$id/bike-models': typeof AppAdminMaterialsIdBikeModelsRoute
  '/app/c/$customerSlug/bike-models/new': typeof AppCCustomerSlugBikeModelsNewRoute
  '/app/c/$customerSlug/bikes/$id': typeof AppCCustomerSlugBikesIdRoute
  '/app/c/$customerSlug/bikes/new': typeof AppCCustomerSlugBikesNewRoute
  '/app/c/$customerSlug/locations/$id': typeof AppCCustomerSlugLocationsIdRoute
  '/app/c/$customerSlug/locations/new': typeof AppCCustomerSlugLocationsNewRoute
  '/app/c/$customerSlug/materials/import': typeof AppCCustomerSlugMaterialsImportRoute
  '/app/c/$customerSlug/materials/import-relations': typeof AppCCustomerSlugMaterialsImportRelationsRoute
  '/app/c/$customerSlug/materials/new': typeof AppCCustomerSlugMaterialsNewRoute
  '/app/c/$customerSlug/requests/$id': typeof AppCCustomerSlugRequestsIdRoute
  '/app/c/$customerSlug/requests/new': typeof AppCCustomerSlugRequestsNewRoute
  '/app/admin/bike-models/$id': typeof AppAdminBikeModelsIdIndexRoute
  '/app/admin/fsm-workflows/document-types': typeof AppAdminFsmWorkflowsDocumentTypesIndexRoute
  '/app/admin/fsm-workflows/entities': typeof AppAdminFsmWorkflowsEntitiesIndexRoute
  '/app/admin/fsm-workflows/entity-types': typeof AppAdminFsmWorkflowsEntityTypesIndexRoute
  '/app/admin/fsm-workflows/states': typeof AppAdminFsmWorkflowsStatesIndexRoute
  '/app/admin/fsm-workflows/transitions': typeof AppAdminFsmWorkflowsTransitionsIndexRoute
  '/app/admin/fsm/document-types': typeof AppAdminFsmDocumentTypesIndexRoute
  '/app/admin/fsm/entities': typeof AppAdminFsmEntitiesIndexRoute
  '/app/admin/fsm/entity-types': typeof AppAdminFsmEntityTypesIndexRoute
  '/app/admin/fsm/states': typeof AppAdminFsmStatesIndexRoute
  '/app/admin/fsm/transitions': typeof AppAdminFsmTransitionsIndexRoute
  '/app/admin/materials/$id': typeof AppAdminMaterialsIdIndexRoute
  '/app/c/$customerSlug/bike-models': typeof AppCCustomerSlugBikeModelsIndexRoute
  '/app/c/$customerSlug/bikes': typeof AppCCustomerSlugBikesIndexRoute
  '/app/c/$customerSlug/locations': typeof AppCCustomerSlugLocationsIndexRoute
  '/app/c/$customerSlug/materials': typeof AppCCustomerSlugMaterialsIndexRoute
  '/app/c/$customerSlug/requests': typeof AppCCustomerSlugRequestsIndexRoute
  '/app/c/$customerSlug/tracking': typeof AppCCustomerSlugTrackingIndexRoute
  '/app/admin/fsm-workflows/workflows': typeof AppAdminFsmWorkflowsWorkflowsIndexLazyRoute
  '/app/admin/fsm/workflows': typeof AppAdminFsmWorkflowsIndexLazyRoute
  '/app/c/$customerSlug/bike-models/$id/materials': typeof AppCCustomerSlugBikeModelsIdMaterialsRoute
  '/app/c/$customerSlug/d/$docTypeSlug/$documentId': typeof AppCCustomerSlugDDocTypeSlugDocumentIdRoute
  '/app/c/$customerSlug/materials/$id/bike-models': typeof AppCCustomerSlugMaterialsIdBikeModelsRoute
  '/app/c/$customerSlug/bike-models/$id': typeof AppCCustomerSlugBikeModelsIdIndexRoute
  '/app/c/$customerSlug/d/$docTypeSlug': typeof AppCCustomerSlugDDocTypeSlugIndexRoute
  '/app/c/$customerSlug/materials/$id': typeof AppCCustomerSlugMaterialsIdIndexRoute
  '/app/c/$customerSlug/reporting/kpi-ops': typeof AppCCustomerSlugReportingKpiOpsIndexRoute
  '/app/c/$customerSlug/reporting/materials-budget': typeof AppCCustomerSlugReportingMaterialsBudgetIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_public': typeof PublicRouteWithChildren
  '/app': typeof AppRouteWithChildren
  '/_public/complete-registration': typeof PublicCompleteRegistrationRoute
  '/_public/login': typeof PublicLoginRoute
  '/_public/privacy': typeof PublicPrivacyRoute
  '/_public/register': typeof PublicRegisterRoute
  '/_public/repair': typeof PublicRepairRoute
  '/app/$customer': typeof AppCustomerRouteWithChildren
  '/app/settings': typeof AppSettingsRouteWithChildren
  '/_public/': typeof PublicIndexRoute
  '/app/': typeof AppIndexRoute
  '/app/admin/bike-models': typeof AppAdminBikeModelsRouteWithChildren
  '/app/admin/bikes': typeof AppAdminBikesRouteWithChildren
  '/app/admin/customers': typeof AppAdminCustomersRouteWithChildren
  '/app/admin/devices': typeof AppAdminDevicesRouteWithChildren
  '/app/admin/fsm': typeof AppAdminFsmRouteWithChildren
  '/app/admin/fsm-workflows': typeof AppAdminFsmWorkflowsRouteWithChildren
  '/app/admin/kpis': typeof AppAdminKpisRouteWithChildren
  '/app/admin/locations': typeof AppAdminLocationsRouteWithChildren
  '/app/admin/map': typeof AppAdminMapRouteWithChildren
  '/app/admin/materials': typeof AppAdminMaterialsRouteWithChildren
  '/app/admin/notification-channels': typeof AppAdminNotificationChannelsRouteWithChildren
  '/app/admin/roles': typeof AppAdminRolesRouteWithChildren
  '/app/admin/stations': typeof AppAdminStationsRouteWithChildren
  '/app/admin/users': typeof AppAdminUsersRouteWithChildren
  '/app/c/$customerSlug': typeof AppCCustomerSlugRouteWithChildren
  '/app/settings/customers': typeof AppSettingsCustomersRouteWithChildren
  '/app/settings/fsm-workflows': typeof AppSettingsFsmWorkflowsRoute
  '/app/$customer/': typeof AppCustomerIndexRoute
  '/app/settings/': typeof AppSettingsIndexRoute
  '/app/$customer/requests/$id': typeof AppCustomerRequestsIdRoute
  '/app/$customer/requests/new': typeof AppCustomerRequestsNewRoute
  '/app/admin/bike-models/$id': typeof AppAdminBikeModelsIdRouteWithChildren
  '/app/admin/bike-models/new': typeof AppAdminBikeModelsNewRoute
  '/app/admin/bikes/$id': typeof AppAdminBikesIdRoute
  '/app/admin/bikes/new': typeof AppAdminBikesNewRoute
  '/app/admin/devices/$id': typeof AppAdminDevicesIdRoute
  '/app/admin/devices/new': typeof AppAdminDevicesNewRoute
  '/app/admin/locations/$id': typeof AppAdminLocationsIdRoute
  '/app/admin/locations/new': typeof AppAdminLocationsNewRoute
  '/app/admin/materials/$id': typeof AppAdminMaterialsIdRouteWithChildren
  '/app/admin/materials/import': typeof AppAdminMaterialsImportRoute
  '/app/admin/materials/import-relations': typeof AppAdminMaterialsImportRelationsRoute
  '/app/admin/materials/new': typeof AppAdminMaterialsNewRoute
  '/app/admin/roles/$id': typeof AppAdminRolesIdRoute
  '/app/admin/stations/$id': typeof AppAdminStationsIdRoute
  '/app/admin/stations/new': typeof AppAdminStationsNewRoute
  '/app/admin/users/$id': typeof AppAdminUsersIdRoute
  '/app/admin/users/invite': typeof AppAdminUsersInviteRoute
  '/app/c/$customerSlug/bike-models': typeof AppCCustomerSlugBikeModelsRouteWithChildren
  '/app/c/$customerSlug/bikes': typeof AppCCustomerSlugBikesRouteWithChildren
  '/app/c/$customerSlug/locations': typeof AppCCustomerSlugLocationsRouteWithChildren
  '/app/c/$customerSlug/materials': typeof AppCCustomerSlugMaterialsRouteWithChildren
  '/app/c/$customerSlug/tracking': typeof AppCCustomerSlugTrackingRouteWithChildren
  '/app/$customer/requests/': typeof AppCustomerRequestsIndexRoute
  '/app/admin/bike-models/': typeof AppAdminBikeModelsIndexRoute
  '/app/admin/bikes/': typeof AppAdminBikesIndexRoute
  '/app/admin/customers/': typeof AppAdminCustomersIndexRoute
  '/app/admin/devices/': typeof AppAdminDevicesIndexRoute
  '/app/admin/fsm-workflows/': typeof AppAdminFsmWorkflowsIndexRoute
  '/app/admin/fsm/': typeof AppAdminFsmIndexRoute
  '/app/admin/kpis/': typeof AppAdminKpisIndexRoute
  '/app/admin/locations/': typeof AppAdminLocationsIndexRoute
  '/app/admin/map/': typeof AppAdminMapIndexRoute
  '/app/admin/materials/': typeof AppAdminMaterialsIndexRoute
  '/app/admin/notification-channels/': typeof AppAdminNotificationChannelsIndexRoute
  '/app/admin/roles/': typeof AppAdminRolesIndexRoute
  '/app/admin/stations/': typeof AppAdminStationsIndexRoute
  '/app/admin/users/': typeof AppAdminUsersIndexRoute
  '/app/settings/customers/': typeof AppSettingsCustomersIndexRoute
  '/app/admin/bike-models/$id/materials': typeof AppAdminBikeModelsIdMaterialsRoute
  '/app/admin/fsm-workflows/document-types/$id': typeof AppAdminFsmWorkflowsDocumentTypesIdRoute
  '/app/admin/fsm-workflows/entities/$id': typeof AppAdminFsmWorkflowsEntitiesIdRoute
  '/app/admin/fsm-workflows/entity-types/$id': typeof AppAdminFsmWorkflowsEntityTypesIdRoute
  '/app/admin/fsm-workflows/states/$id': typeof AppAdminFsmWorkflowsStatesIdRoute
  '/app/admin/fsm-workflows/transitions/$id': typeof AppAdminFsmWorkflowsTransitionsIdRoute
  '/app/admin/fsm/document-types/$id': typeof AppAdminFsmDocumentTypesIdRoute
  '/app/admin/fsm/entities/$id': typeof AppAdminFsmEntitiesIdRoute
  '/app/admin/fsm/entity-types/$id': typeof AppAdminFsmEntityTypesIdRoute
  '/app/admin/fsm/states/$id': typeof AppAdminFsmStatesIdRoute
  '/app/admin/fsm/transitions/$id': typeof AppAdminFsmTransitionsIdRoute
  '/app/admin/materials/$id/bike-models': typeof AppAdminMaterialsIdBikeModelsRoute
  '/app/c/$customerSlug/bike-models/$id': typeof AppCCustomerSlugBikeModelsIdRouteWithChildren
  '/app/c/$customerSlug/bike-models/new': typeof AppCCustomerSlugBikeModelsNewRoute
  '/app/c/$customerSlug/bikes/$id': typeof AppCCustomerSlugBikesIdRoute
  '/app/c/$customerSlug/bikes/new': typeof AppCCustomerSlugBikesNewRoute
  '/app/c/$customerSlug/d/$docTypeSlug': typeof AppCCustomerSlugDDocTypeSlugRouteWithChildren
  '/app/c/$customerSlug/locations/$id': typeof AppCCustomerSlugLocationsIdRoute
  '/app/c/$customerSlug/locations/new': typeof AppCCustomerSlugLocationsNewRoute
  '/app/c/$customerSlug/materials/$id': typeof AppCCustomerSlugMaterialsIdRouteWithChildren
  '/app/c/$customerSlug/materials/import': typeof AppCCustomerSlugMaterialsImportRoute
  '/app/c/$customerSlug/materials/import-relations': typeof AppCCustomerSlugMaterialsImportRelationsRoute
  '/app/c/$customerSlug/materials/new': typeof AppCCustomerSlugMaterialsNewRoute
  '/app/c/$customerSlug/reporting/kpi-ops': typeof AppCCustomerSlugReportingKpiOpsRouteWithChildren
  '/app/c/$customerSlug/reporting/materials-budget': typeof AppCCustomerSlugReportingMaterialsBudgetRouteWithChildren
  '/app/c/$customerSlug/requests/$id': typeof AppCCustomerSlugRequestsIdRoute
  '/app/c/$customerSlug/requests/new': typeof AppCCustomerSlugRequestsNewRoute
  '/app/admin/bike-models/$id/': typeof AppAdminBikeModelsIdIndexRoute
  '/app/admin/fsm-workflows/document-types/': typeof AppAdminFsmWorkflowsDocumentTypesIndexRoute
  '/app/admin/fsm-workflows/entities/': typeof AppAdminFsmWorkflowsEntitiesIndexRoute
  '/app/admin/fsm-workflows/entity-types/': typeof AppAdminFsmWorkflowsEntityTypesIndexRoute
  '/app/admin/fsm-workflows/states/': typeof AppAdminFsmWorkflowsStatesIndexRoute
  '/app/admin/fsm-workflows/transitions/': typeof AppAdminFsmWorkflowsTransitionsIndexRoute
  '/app/admin/fsm/document-types/': typeof AppAdminFsmDocumentTypesIndexRoute
  '/app/admin/fsm/entities/': typeof AppAdminFsmEntitiesIndexRoute
  '/app/admin/fsm/entity-types/': typeof AppAdminFsmEntityTypesIndexRoute
  '/app/admin/fsm/states/': typeof AppAdminFsmStatesIndexRoute
  '/app/admin/fsm/transitions/': typeof AppAdminFsmTransitionsIndexRoute
  '/app/admin/materials/$id/': typeof AppAdminMaterialsIdIndexRoute
  '/app/c/$customerSlug/bike-models/': typeof AppCCustomerSlugBikeModelsIndexRoute
  '/app/c/$customerSlug/bikes/': typeof AppCCustomerSlugBikesIndexRoute
  '/app/c/$customerSlug/locations/': typeof AppCCustomerSlugLocationsIndexRoute
  '/app/c/$customerSlug/materials/': typeof AppCCustomerSlugMaterialsIndexRoute
  '/app/c/$customerSlug/requests/': typeof AppCCustomerSlugRequestsIndexRoute
  '/app/c/$customerSlug/tracking/': typeof AppCCustomerSlugTrackingIndexRoute
  '/app/admin/fsm-workflows/workflows/': typeof AppAdminFsmWorkflowsWorkflowsIndexLazyRoute
  '/app/admin/fsm/workflows/': typeof AppAdminFsmWorkflowsIndexLazyRoute
  '/app/c/$customerSlug/bike-models/$id/materials': typeof AppCCustomerSlugBikeModelsIdMaterialsRoute
  '/app/c/$customerSlug/d/$docTypeSlug/$documentId': typeof AppCCustomerSlugDDocTypeSlugDocumentIdRoute
  '/app/c/$customerSlug/materials/$id/bike-models': typeof AppCCustomerSlugMaterialsIdBikeModelsRoute
  '/app/c/$customerSlug/bike-models/$id/': typeof AppCCustomerSlugBikeModelsIdIndexRoute
  '/app/c/$customerSlug/d/$docTypeSlug/': typeof AppCCustomerSlugDDocTypeSlugIndexRoute
  '/app/c/$customerSlug/materials/$id/': typeof AppCCustomerSlugMaterialsIdIndexRoute
  '/app/c/$customerSlug/reporting/kpi-ops/': typeof AppCCustomerSlugReportingKpiOpsIndexRoute
  '/app/c/$customerSlug/reporting/materials-budget/': typeof AppCCustomerSlugReportingMaterialsBudgetIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/app'
    | '/complete-registration'
    | '/login'
    | '/privacy'
    | '/register'
    | '/repair'
    | '/app/$customer'
    | '/app/settings'
    | '/app/'
    | '/app/admin/bike-models'
    | '/app/admin/bikes'
    | '/app/admin/customers'
    | '/app/admin/devices'
    | '/app/admin/fsm'
    | '/app/admin/fsm-workflows'
    | '/app/admin/kpis'
    | '/app/admin/locations'
    | '/app/admin/map'
    | '/app/admin/materials'
    | '/app/admin/notification-channels'
    | '/app/admin/roles'
    | '/app/admin/stations'
    | '/app/admin/users'
    | '/app/c/$customerSlug'
    | '/app/settings/customers'
    | '/app/settings/fsm-workflows'
    | '/app/$customer/'
    | '/app/settings/'
    | '/app/$customer/requests/$id'
    | '/app/$customer/requests/new'
    | '/app/admin/bike-models/$id'
    | '/app/admin/bike-models/new'
    | '/app/admin/bikes/$id'
    | '/app/admin/bikes/new'
    | '/app/admin/devices/$id'
    | '/app/admin/devices/new'
    | '/app/admin/locations/$id'
    | '/app/admin/locations/new'
    | '/app/admin/materials/$id'
    | '/app/admin/materials/import'
    | '/app/admin/materials/import-relations'
    | '/app/admin/materials/new'
    | '/app/admin/roles/$id'
    | '/app/admin/stations/$id'
    | '/app/admin/stations/new'
    | '/app/admin/users/$id'
    | '/app/admin/users/invite'
    | '/app/c/$customerSlug/bike-models'
    | '/app/c/$customerSlug/bikes'
    | '/app/c/$customerSlug/locations'
    | '/app/c/$customerSlug/materials'
    | '/app/c/$customerSlug/tracking'
    | '/app/$customer/requests/'
    | '/app/admin/bike-models/'
    | '/app/admin/bikes/'
    | '/app/admin/customers/'
    | '/app/admin/devices/'
    | '/app/admin/fsm-workflows/'
    | '/app/admin/fsm/'
    | '/app/admin/kpis/'
    | '/app/admin/locations/'
    | '/app/admin/map/'
    | '/app/admin/materials/'
    | '/app/admin/notification-channels/'
    | '/app/admin/roles/'
    | '/app/admin/stations/'
    | '/app/admin/users/'
    | '/app/settings/customers/'
    | '/app/admin/bike-models/$id/materials'
    | '/app/admin/fsm-workflows/document-types/$id'
    | '/app/admin/fsm-workflows/entities/$id'
    | '/app/admin/fsm-workflows/entity-types/$id'
    | '/app/admin/fsm-workflows/states/$id'
    | '/app/admin/fsm-workflows/transitions/$id'
    | '/app/admin/fsm/document-types/$id'
    | '/app/admin/fsm/entities/$id'
    | '/app/admin/fsm/entity-types/$id'
    | '/app/admin/fsm/states/$id'
    | '/app/admin/fsm/transitions/$id'
    | '/app/admin/materials/$id/bike-models'
    | '/app/c/$customerSlug/bike-models/$id'
    | '/app/c/$customerSlug/bike-models/new'
    | '/app/c/$customerSlug/bikes/$id'
    | '/app/c/$customerSlug/bikes/new'
    | '/app/c/$customerSlug/d/$docTypeSlug'
    | '/app/c/$customerSlug/locations/$id'
    | '/app/c/$customerSlug/locations/new'
    | '/app/c/$customerSlug/materials/$id'
    | '/app/c/$customerSlug/materials/import'
    | '/app/c/$customerSlug/materials/import-relations'
    | '/app/c/$customerSlug/materials/new'
    | '/app/c/$customerSlug/reporting/kpi-ops'
    | '/app/c/$customerSlug/reporting/materials-budget'
    | '/app/c/$customerSlug/requests/$id'
    | '/app/c/$customerSlug/requests/new'
    | '/app/admin/bike-models/$id/'
    | '/app/admin/fsm-workflows/document-types/'
    | '/app/admin/fsm-workflows/entities/'
    | '/app/admin/fsm-workflows/entity-types/'
    | '/app/admin/fsm-workflows/states/'
    | '/app/admin/fsm-workflows/transitions/'
    | '/app/admin/fsm/document-types/'
    | '/app/admin/fsm/entities/'
    | '/app/admin/fsm/entity-types/'
    | '/app/admin/fsm/states/'
    | '/app/admin/fsm/transitions/'
    | '/app/admin/materials/$id/'
    | '/app/c/$customerSlug/bike-models/'
    | '/app/c/$customerSlug/bikes/'
    | '/app/c/$customerSlug/locations/'
    | '/app/c/$customerSlug/materials/'
    | '/app/c/$customerSlug/requests/'
    | '/app/c/$customerSlug/tracking/'
    | '/app/admin/fsm-workflows/workflows/'
    | '/app/admin/fsm/workflows/'
    | '/app/c/$customerSlug/bike-models/$id/materials'
    | '/app/c/$customerSlug/d/$docTypeSlug/$documentId'
    | '/app/c/$customerSlug/materials/$id/bike-models'
    | '/app/c/$customerSlug/bike-models/$id/'
    | '/app/c/$customerSlug/d/$docTypeSlug/'
    | '/app/c/$customerSlug/materials/$id/'
    | '/app/c/$customerSlug/reporting/kpi-ops/'
    | '/app/c/$customerSlug/reporting/materials-budget/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/complete-registration'
    | '/login'
    | '/privacy'
    | '/register'
    | '/repair'
    | '/'
    | '/app'
    | '/app/c/$customerSlug'
    | '/app/settings/fsm-workflows'
    | '/app/$customer'
    | '/app/settings'
    | '/app/$customer/requests/$id'
    | '/app/$customer/requests/new'
    | '/app/admin/bike-models/new'
    | '/app/admin/bikes/$id'
    | '/app/admin/bikes/new'
    | '/app/admin/devices/$id'
    | '/app/admin/devices/new'
    | '/app/admin/locations/$id'
    | '/app/admin/locations/new'
    | '/app/admin/materials/import'
    | '/app/admin/materials/import-relations'
    | '/app/admin/materials/new'
    | '/app/admin/roles/$id'
    | '/app/admin/stations/$id'
    | '/app/admin/stations/new'
    | '/app/admin/users/$id'
    | '/app/admin/users/invite'
    | '/app/$customer/requests'
    | '/app/admin/bike-models'
    | '/app/admin/bikes'
    | '/app/admin/customers'
    | '/app/admin/devices'
    | '/app/admin/fsm-workflows'
    | '/app/admin/fsm'
    | '/app/admin/kpis'
    | '/app/admin/locations'
    | '/app/admin/map'
    | '/app/admin/materials'
    | '/app/admin/notification-channels'
    | '/app/admin/roles'
    | '/app/admin/stations'
    | '/app/admin/users'
    | '/app/settings/customers'
    | '/app/admin/bike-models/$id/materials'
    | '/app/admin/fsm-workflows/document-types/$id'
    | '/app/admin/fsm-workflows/entities/$id'
    | '/app/admin/fsm-workflows/entity-types/$id'
    | '/app/admin/fsm-workflows/states/$id'
    | '/app/admin/fsm-workflows/transitions/$id'
    | '/app/admin/fsm/document-types/$id'
    | '/app/admin/fsm/entities/$id'
    | '/app/admin/fsm/entity-types/$id'
    | '/app/admin/fsm/states/$id'
    | '/app/admin/fsm/transitions/$id'
    | '/app/admin/materials/$id/bike-models'
    | '/app/c/$customerSlug/bike-models/new'
    | '/app/c/$customerSlug/bikes/$id'
    | '/app/c/$customerSlug/bikes/new'
    | '/app/c/$customerSlug/locations/$id'
    | '/app/c/$customerSlug/locations/new'
    | '/app/c/$customerSlug/materials/import'
    | '/app/c/$customerSlug/materials/import-relations'
    | '/app/c/$customerSlug/materials/new'
    | '/app/c/$customerSlug/requests/$id'
    | '/app/c/$customerSlug/requests/new'
    | '/app/admin/bike-models/$id'
    | '/app/admin/fsm-workflows/document-types'
    | '/app/admin/fsm-workflows/entities'
    | '/app/admin/fsm-workflows/entity-types'
    | '/app/admin/fsm-workflows/states'
    | '/app/admin/fsm-workflows/transitions'
    | '/app/admin/fsm/document-types'
    | '/app/admin/fsm/entities'
    | '/app/admin/fsm/entity-types'
    | '/app/admin/fsm/states'
    | '/app/admin/fsm/transitions'
    | '/app/admin/materials/$id'
    | '/app/c/$customerSlug/bike-models'
    | '/app/c/$customerSlug/bikes'
    | '/app/c/$customerSlug/locations'
    | '/app/c/$customerSlug/materials'
    | '/app/c/$customerSlug/requests'
    | '/app/c/$customerSlug/tracking'
    | '/app/admin/fsm-workflows/workflows'
    | '/app/admin/fsm/workflows'
    | '/app/c/$customerSlug/bike-models/$id/materials'
    | '/app/c/$customerSlug/d/$docTypeSlug/$documentId'
    | '/app/c/$customerSlug/materials/$id/bike-models'
    | '/app/c/$customerSlug/bike-models/$id'
    | '/app/c/$customerSlug/d/$docTypeSlug'
    | '/app/c/$customerSlug/materials/$id'
    | '/app/c/$customerSlug/reporting/kpi-ops'
    | '/app/c/$customerSlug/reporting/materials-budget'
  id:
    | '__root__'
    | '/_public'
    | '/app'
    | '/_public/complete-registration'
    | '/_public/login'
    | '/_public/privacy'
    | '/_public/register'
    | '/_public/repair'
    | '/app/$customer'
    | '/app/settings'
    | '/_public/'
    | '/app/'
    | '/app/admin/bike-models'
    | '/app/admin/bikes'
    | '/app/admin/customers'
    | '/app/admin/devices'
    | '/app/admin/fsm'
    | '/app/admin/fsm-workflows'
    | '/app/admin/kpis'
    | '/app/admin/locations'
    | '/app/admin/map'
    | '/app/admin/materials'
    | '/app/admin/notification-channels'
    | '/app/admin/roles'
    | '/app/admin/stations'
    | '/app/admin/users'
    | '/app/c/$customerSlug'
    | '/app/settings/customers'
    | '/app/settings/fsm-workflows'
    | '/app/$customer/'
    | '/app/settings/'
    | '/app/$customer/requests/$id'
    | '/app/$customer/requests/new'
    | '/app/admin/bike-models/$id'
    | '/app/admin/bike-models/new'
    | '/app/admin/bikes/$id'
    | '/app/admin/bikes/new'
    | '/app/admin/devices/$id'
    | '/app/admin/devices/new'
    | '/app/admin/locations/$id'
    | '/app/admin/locations/new'
    | '/app/admin/materials/$id'
    | '/app/admin/materials/import'
    | '/app/admin/materials/import-relations'
    | '/app/admin/materials/new'
    | '/app/admin/roles/$id'
    | '/app/admin/stations/$id'
    | '/app/admin/stations/new'
    | '/app/admin/users/$id'
    | '/app/admin/users/invite'
    | '/app/c/$customerSlug/bike-models'
    | '/app/c/$customerSlug/bikes'
    | '/app/c/$customerSlug/locations'
    | '/app/c/$customerSlug/materials'
    | '/app/c/$customerSlug/tracking'
    | '/app/$customer/requests/'
    | '/app/admin/bike-models/'
    | '/app/admin/bikes/'
    | '/app/admin/customers/'
    | '/app/admin/devices/'
    | '/app/admin/fsm-workflows/'
    | '/app/admin/fsm/'
    | '/app/admin/kpis/'
    | '/app/admin/locations/'
    | '/app/admin/map/'
    | '/app/admin/materials/'
    | '/app/admin/notification-channels/'
    | '/app/admin/roles/'
    | '/app/admin/stations/'
    | '/app/admin/users/'
    | '/app/settings/customers/'
    | '/app/admin/bike-models/$id/materials'
    | '/app/admin/fsm-workflows/document-types/$id'
    | '/app/admin/fsm-workflows/entities/$id'
    | '/app/admin/fsm-workflows/entity-types/$id'
    | '/app/admin/fsm-workflows/states/$id'
    | '/app/admin/fsm-workflows/transitions/$id'
    | '/app/admin/fsm/document-types/$id'
    | '/app/admin/fsm/entities/$id'
    | '/app/admin/fsm/entity-types/$id'
    | '/app/admin/fsm/states/$id'
    | '/app/admin/fsm/transitions/$id'
    | '/app/admin/materials/$id/bike-models'
    | '/app/c/$customerSlug/bike-models/$id'
    | '/app/c/$customerSlug/bike-models/new'
    | '/app/c/$customerSlug/bikes/$id'
    | '/app/c/$customerSlug/bikes/new'
    | '/app/c/$customerSlug/d/$docTypeSlug'
    | '/app/c/$customerSlug/locations/$id'
    | '/app/c/$customerSlug/locations/new'
    | '/app/c/$customerSlug/materials/$id'
    | '/app/c/$customerSlug/materials/import'
    | '/app/c/$customerSlug/materials/import-relations'
    | '/app/c/$customerSlug/materials/new'
    | '/app/c/$customerSlug/reporting/kpi-ops'
    | '/app/c/$customerSlug/reporting/materials-budget'
    | '/app/c/$customerSlug/requests/$id'
    | '/app/c/$customerSlug/requests/new'
    | '/app/admin/bike-models/$id/'
    | '/app/admin/fsm-workflows/document-types/'
    | '/app/admin/fsm-workflows/entities/'
    | '/app/admin/fsm-workflows/entity-types/'
    | '/app/admin/fsm-workflows/states/'
    | '/app/admin/fsm-workflows/transitions/'
    | '/app/admin/fsm/document-types/'
    | '/app/admin/fsm/entities/'
    | '/app/admin/fsm/entity-types/'
    | '/app/admin/fsm/states/'
    | '/app/admin/fsm/transitions/'
    | '/app/admin/materials/$id/'
    | '/app/c/$customerSlug/bike-models/'
    | '/app/c/$customerSlug/bikes/'
    | '/app/c/$customerSlug/locations/'
    | '/app/c/$customerSlug/materials/'
    | '/app/c/$customerSlug/requests/'
    | '/app/c/$customerSlug/tracking/'
    | '/app/admin/fsm-workflows/workflows/'
    | '/app/admin/fsm/workflows/'
    | '/app/c/$customerSlug/bike-models/$id/materials'
    | '/app/c/$customerSlug/d/$docTypeSlug/$documentId'
    | '/app/c/$customerSlug/materials/$id/bike-models'
    | '/app/c/$customerSlug/bike-models/$id/'
    | '/app/c/$customerSlug/d/$docTypeSlug/'
    | '/app/c/$customerSlug/materials/$id/'
    | '/app/c/$customerSlug/reporting/kpi-ops/'
    | '/app/c/$customerSlug/reporting/materials-budget/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  PublicRoute: typeof PublicRouteWithChildren
  AppRoute: typeof AppRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/app': {
      id: '/app'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PublicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/': {
      id: '/app/'
      path: '/'
      fullPath: '/app/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_public/': {
      id: '/_public/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof PublicIndexRouteImport
      parentRoute: typeof PublicRoute
    }
    '/app/settings': {
      id: '/app/settings'
      path: '/settings'
      fullPath: '/app/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/$customer': {
      id: '/app/$customer'
      path: '/$customer'
      fullPath: '/app/$customer'
      preLoaderRoute: typeof AppCustomerRouteImport
      parentRoute: typeof AppRoute
    }
    '/_public/repair': {
      id: '/_public/repair'
      path: '/repair'
      fullPath: '/repair'
      preLoaderRoute: typeof PublicRepairRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/register': {
      id: '/_public/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof PublicRegisterRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/privacy': {
      id: '/_public/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PublicPrivacyRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/login': {
      id: '/_public/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof PublicLoginRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/complete-registration': {
      id: '/_public/complete-registration'
      path: '/complete-registration'
      fullPath: '/complete-registration'
      preLoaderRoute: typeof PublicCompleteRegistrationRouteImport
      parentRoute: typeof PublicRoute
    }
    '/app/settings/': {
      id: '/app/settings/'
      path: '/'
      fullPath: '/app/settings/'
      preLoaderRoute: typeof AppSettingsIndexRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/app/$customer/': {
      id: '/app/$customer/'
      path: '/'
      fullPath: '/app/$customer/'
      preLoaderRoute: typeof AppCustomerIndexRouteImport
      parentRoute: typeof AppCustomerRoute
    }
    '/app/settings/fsm-workflows': {
      id: '/app/settings/fsm-workflows'
      path: '/fsm-workflows'
      fullPath: '/app/settings/fsm-workflows'
      preLoaderRoute: typeof AppSettingsFsmWorkflowsRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/app/settings/customers': {
      id: '/app/settings/customers'
      path: '/customers'
      fullPath: '/app/settings/customers'
      preLoaderRoute: typeof AppSettingsCustomersRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/app/c/$customerSlug': {
      id: '/app/c/$customerSlug'
      path: '/c/$customerSlug'
      fullPath: '/app/c/$customerSlug'
      preLoaderRoute: typeof AppCCustomerSlugRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/admin/users': {
      id: '/app/admin/users'
      path: '/admin/users'
      fullPath: '/app/admin/users'
      preLoaderRoute: typeof AppAdminUsersRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/admin/stations': {
      id: '/app/admin/stations'
      path: '/admin/stations'
      fullPath: '/app/admin/stations'
      preLoaderRoute: typeof AppAdminStationsRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/admin/roles': {
      id: '/app/admin/roles'
      path: '/admin/roles'
      fullPath: '/app/admin/roles'
      preLoaderRoute: typeof AppAdminRolesRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/admin/notification-channels': {
      id: '/app/admin/notification-channels'
      path: '/admin/notification-channels'
      fullPath: '/app/admin/notification-channels'
      preLoaderRoute: typeof AppAdminNotificationChannelsRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/admin/materials': {
      id: '/app/admin/materials'
      path: '/admin/materials'
      fullPath: '/app/admin/materials'
      preLoaderRoute: typeof AppAdminMaterialsRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/admin/map': {
      id: '/app/admin/map'
      path: '/admin/map'
      fullPath: '/app/admin/map'
      preLoaderRoute: typeof AppAdminMapRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/admin/locations': {
      id: '/app/admin/locations'
      path: '/admin/locations'
      fullPath: '/app/admin/locations'
      preLoaderRoute: typeof AppAdminLocationsRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/admin/kpis': {
      id: '/app/admin/kpis'
      path: '/admin/kpis'
      fullPath: '/app/admin/kpis'
      preLoaderRoute: typeof AppAdminKpisRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/admin/fsm-workflows': {
      id: '/app/admin/fsm-workflows'
      path: '/admin/fsm-workflows'
      fullPath: '/app/admin/fsm-workflows'
      preLoaderRoute: typeof AppAdminFsmWorkflowsRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/admin/fsm': {
      id: '/app/admin/fsm'
      path: '/admin/fsm'
      fullPath: '/app/admin/fsm'
      preLoaderRoute: typeof AppAdminFsmRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/admin/devices': {
      id: '/app/admin/devices'
      path: '/admin/devices'
      fullPath: '/app/admin/devices'
      preLoaderRoute: typeof AppAdminDevicesRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/admin/customers': {
      id: '/app/admin/customers'
      path: '/admin/customers'
      fullPath: '/app/admin/customers'
      preLoaderRoute: typeof AppAdminCustomersRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/admin/bikes': {
      id: '/app/admin/bikes'
      path: '/admin/bikes'
      fullPath: '/app/admin/bikes'
      preLoaderRoute: typeof AppAdminBikesRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/admin/bike-models': {
      id: '/app/admin/bike-models'
      path: '/admin/bike-models'
      fullPath: '/app/admin/bike-models'
      preLoaderRoute: typeof AppAdminBikeModelsRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/settings/customers/': {
      id: '/app/settings/customers/'
      path: '/'
      fullPath: '/app/settings/customers/'
      preLoaderRoute: typeof AppSettingsCustomersIndexRouteImport
      parentRoute: typeof AppSettingsCustomersRoute
    }
    '/app/admin/users/': {
      id: '/app/admin/users/'
      path: '/'
      fullPath: '/app/admin/users/'
      preLoaderRoute: typeof AppAdminUsersIndexRouteImport
      parentRoute: typeof AppAdminUsersRoute
    }
    '/app/admin/stations/': {
      id: '/app/admin/stations/'
      path: '/'
      fullPath: '/app/admin/stations/'
      preLoaderRoute: typeof AppAdminStationsIndexRouteImport
      parentRoute: typeof AppAdminStationsRoute
    }
    '/app/admin/roles/': {
      id: '/app/admin/roles/'
      path: '/'
      fullPath: '/app/admin/roles/'
      preLoaderRoute: typeof AppAdminRolesIndexRouteImport
      parentRoute: typeof AppAdminRolesRoute
    }
    '/app/admin/notification-channels/': {
      id: '/app/admin/notification-channels/'
      path: '/'
      fullPath: '/app/admin/notification-channels/'
      preLoaderRoute: typeof AppAdminNotificationChannelsIndexRouteImport
      parentRoute: typeof AppAdminNotificationChannelsRoute
    }
    '/app/admin/materials/': {
      id: '/app/admin/materials/'
      path: '/'
      fullPath: '/app/admin/materials/'
      preLoaderRoute: typeof AppAdminMaterialsIndexRouteImport
      parentRoute: typeof AppAdminMaterialsRoute
    }
    '/app/admin/map/': {
      id: '/app/admin/map/'
      path: '/'
      fullPath: '/app/admin/map/'
      preLoaderRoute: typeof AppAdminMapIndexRouteImport
      parentRoute: typeof AppAdminMapRoute
    }
    '/app/admin/locations/': {
      id: '/app/admin/locations/'
      path: '/'
      fullPath: '/app/admin/locations/'
      preLoaderRoute: typeof AppAdminLocationsIndexRouteImport
      parentRoute: typeof AppAdminLocationsRoute
    }
    '/app/admin/kpis/': {
      id: '/app/admin/kpis/'
      path: '/'
      fullPath: '/app/admin/kpis/'
      preLoaderRoute: typeof AppAdminKpisIndexRouteImport
      parentRoute: typeof AppAdminKpisRoute
    }
    '/app/admin/fsm/': {
      id: '/app/admin/fsm/'
      path: '/'
      fullPath: '/app/admin/fsm/'
      preLoaderRoute: typeof AppAdminFsmIndexRouteImport
      parentRoute: typeof AppAdminFsmRoute
    }
    '/app/admin/fsm-workflows/': {
      id: '/app/admin/fsm-workflows/'
      path: '/'
      fullPath: '/app/admin/fsm-workflows/'
      preLoaderRoute: typeof AppAdminFsmWorkflowsIndexRouteImport
      parentRoute: typeof AppAdminFsmWorkflowsRoute
    }
    '/app/admin/devices/': {
      id: '/app/admin/devices/'
      path: '/'
      fullPath: '/app/admin/devices/'
      preLoaderRoute: typeof AppAdminDevicesIndexRouteImport
      parentRoute: typeof AppAdminDevicesRoute
    }
    '/app/admin/customers/': {
      id: '/app/admin/customers/'
      path: '/'
      fullPath: '/app/admin/customers/'
      preLoaderRoute: typeof AppAdminCustomersIndexRouteImport
      parentRoute: typeof AppAdminCustomersRoute
    }
    '/app/admin/bikes/': {
      id: '/app/admin/bikes/'
      path: '/'
      fullPath: '/app/admin/bikes/'
      preLoaderRoute: typeof AppAdminBikesIndexRouteImport
      parentRoute: typeof AppAdminBikesRoute
    }
    '/app/admin/bike-models/': {
      id: '/app/admin/bike-models/'
      path: '/'
      fullPath: '/app/admin/bike-models/'
      preLoaderRoute: typeof AppAdminBikeModelsIndexRouteImport
      parentRoute: typeof AppAdminBikeModelsRoute
    }
    '/app/$customer/requests/': {
      id: '/app/$customer/requests/'
      path: '/requests'
      fullPath: '/app/$customer/requests/'
      preLoaderRoute: typeof AppCustomerRequestsIndexRouteImport
      parentRoute: typeof AppCustomerRoute
    }
    '/app/c/$customerSlug/tracking': {
      id: '/app/c/$customerSlug/tracking'
      path: '/tracking'
      fullPath: '/app/c/$customerSlug/tracking'
      preLoaderRoute: typeof AppCCustomerSlugTrackingRouteImport
      parentRoute: typeof AppCCustomerSlugRoute
    }
    '/app/c/$customerSlug/materials': {
      id: '/app/c/$customerSlug/materials'
      path: '/materials'
      fullPath: '/app/c/$customerSlug/materials'
      preLoaderRoute: typeof AppCCustomerSlugMaterialsRouteImport
      parentRoute: typeof AppCCustomerSlugRoute
    }
    '/app/c/$customerSlug/locations': {
      id: '/app/c/$customerSlug/locations'
      path: '/locations'
      fullPath: '/app/c/$customerSlug/locations'
      preLoaderRoute: typeof AppCCustomerSlugLocationsRouteImport
      parentRoute: typeof AppCCustomerSlugRoute
    }
    '/app/c/$customerSlug/bikes': {
      id: '/app/c/$customerSlug/bikes'
      path: '/bikes'
      fullPath: '/app/c/$customerSlug/bikes'
      preLoaderRoute: typeof AppCCustomerSlugBikesRouteImport
      parentRoute: typeof AppCCustomerSlugRoute
    }
    '/app/c/$customerSlug/bike-models': {
      id: '/app/c/$customerSlug/bike-models'
      path: '/bike-models'
      fullPath: '/app/c/$customerSlug/bike-models'
      preLoaderRoute: typeof AppCCustomerSlugBikeModelsRouteImport
      parentRoute: typeof AppCCustomerSlugRoute
    }
    '/app/admin/users/invite': {
      id: '/app/admin/users/invite'
      path: '/invite'
      fullPath: '/app/admin/users/invite'
      preLoaderRoute: typeof AppAdminUsersInviteRouteImport
      parentRoute: typeof AppAdminUsersRoute
    }
    '/app/admin/users/$id': {
      id: '/app/admin/users/$id'
      path: '/$id'
      fullPath: '/app/admin/users/$id'
      preLoaderRoute: typeof AppAdminUsersIdRouteImport
      parentRoute: typeof AppAdminUsersRoute
    }
    '/app/admin/stations/new': {
      id: '/app/admin/stations/new'
      path: '/new'
      fullPath: '/app/admin/stations/new'
      preLoaderRoute: typeof AppAdminStationsNewRouteImport
      parentRoute: typeof AppAdminStationsRoute
    }
    '/app/admin/stations/$id': {
      id: '/app/admin/stations/$id'
      path: '/$id'
      fullPath: '/app/admin/stations/$id'
      preLoaderRoute: typeof AppAdminStationsIdRouteImport
      parentRoute: typeof AppAdminStationsRoute
    }
    '/app/admin/roles/$id': {
      id: '/app/admin/roles/$id'
      path: '/$id'
      fullPath: '/app/admin/roles/$id'
      preLoaderRoute: typeof AppAdminRolesIdRouteImport
      parentRoute: typeof AppAdminRolesRoute
    }
    '/app/admin/materials/new': {
      id: '/app/admin/materials/new'
      path: '/new'
      fullPath: '/app/admin/materials/new'
      preLoaderRoute: typeof AppAdminMaterialsNewRouteImport
      parentRoute: typeof AppAdminMaterialsRoute
    }
    '/app/admin/materials/import-relations': {
      id: '/app/admin/materials/import-relations'
      path: '/import-relations'
      fullPath: '/app/admin/materials/import-relations'
      preLoaderRoute: typeof AppAdminMaterialsImportRelationsRouteImport
      parentRoute: typeof AppAdminMaterialsRoute
    }
    '/app/admin/materials/import': {
      id: '/app/admin/materials/import'
      path: '/import'
      fullPath: '/app/admin/materials/import'
      preLoaderRoute: typeof AppAdminMaterialsImportRouteImport
      parentRoute: typeof AppAdminMaterialsRoute
    }
    '/app/admin/materials/$id': {
      id: '/app/admin/materials/$id'
      path: '/$id'
      fullPath: '/app/admin/materials/$id'
      preLoaderRoute: typeof AppAdminMaterialsIdRouteImport
      parentRoute: typeof AppAdminMaterialsRoute
    }
    '/app/admin/locations/new': {
      id: '/app/admin/locations/new'
      path: '/new'
      fullPath: '/app/admin/locations/new'
      preLoaderRoute: typeof AppAdminLocationsNewRouteImport
      parentRoute: typeof AppAdminLocationsRoute
    }
    '/app/admin/locations/$id': {
      id: '/app/admin/locations/$id'
      path: '/$id'
      fullPath: '/app/admin/locations/$id'
      preLoaderRoute: typeof AppAdminLocationsIdRouteImport
      parentRoute: typeof AppAdminLocationsRoute
    }
    '/app/admin/devices/new': {
      id: '/app/admin/devices/new'
      path: '/new'
      fullPath: '/app/admin/devices/new'
      preLoaderRoute: typeof AppAdminDevicesNewRouteImport
      parentRoute: typeof AppAdminDevicesRoute
    }
    '/app/admin/devices/$id': {
      id: '/app/admin/devices/$id'
      path: '/$id'
      fullPath: '/app/admin/devices/$id'
      preLoaderRoute: typeof AppAdminDevicesIdRouteImport
      parentRoute: typeof AppAdminDevicesRoute
    }
    '/app/admin/bikes/new': {
      id: '/app/admin/bikes/new'
      path: '/new'
      fullPath: '/app/admin/bikes/new'
      preLoaderRoute: typeof AppAdminBikesNewRouteImport
      parentRoute: typeof AppAdminBikesRoute
    }
    '/app/admin/bikes/$id': {
      id: '/app/admin/bikes/$id'
      path: '/$id'
      fullPath: '/app/admin/bikes/$id'
      preLoaderRoute: typeof AppAdminBikesIdRouteImport
      parentRoute: typeof AppAdminBikesRoute
    }
    '/app/admin/bike-models/new': {
      id: '/app/admin/bike-models/new'
      path: '/new'
      fullPath: '/app/admin/bike-models/new'
      preLoaderRoute: typeof AppAdminBikeModelsNewRouteImport
      parentRoute: typeof AppAdminBikeModelsRoute
    }
    '/app/admin/bike-models/$id': {
      id: '/app/admin/bike-models/$id'
      path: '/$id'
      fullPath: '/app/admin/bike-models/$id'
      preLoaderRoute: typeof AppAdminBikeModelsIdRouteImport
      parentRoute: typeof AppAdminBikeModelsRoute
    }
    '/app/$customer/requests/new': {
      id: '/app/$customer/requests/new'
      path: '/requests/new'
      fullPath: '/app/$customer/requests/new'
      preLoaderRoute: typeof AppCustomerRequestsNewRouteImport
      parentRoute: typeof AppCustomerRoute
    }
    '/app/$customer/requests/$id': {
      id: '/app/$customer/requests/$id'
      path: '/requests/$id'
      fullPath: '/app/$customer/requests/$id'
      preLoaderRoute: typeof AppCustomerRequestsIdRouteImport
      parentRoute: typeof AppCustomerRoute
    }
    '/app/admin/fsm/workflows/': {
      id: '/app/admin/fsm/workflows/'
      path: '/workflows'
      fullPath: '/app/admin/fsm/workflows/'
      preLoaderRoute: typeof AppAdminFsmWorkflowsIndexLazyRouteImport
      parentRoute: typeof AppAdminFsmRoute
    }
    '/app/admin/fsm-workflows/workflows/': {
      id: '/app/admin/fsm-workflows/workflows/'
      path: '/workflows'
      fullPath: '/app/admin/fsm-workflows/workflows/'
      preLoaderRoute: typeof AppAdminFsmWorkflowsWorkflowsIndexLazyRouteImport
      parentRoute: typeof AppAdminFsmWorkflowsRoute
    }
    '/app/c/$customerSlug/tracking/': {
      id: '/app/c/$customerSlug/tracking/'
      path: '/'
      fullPath: '/app/c/$customerSlug/tracking/'
      preLoaderRoute: typeof AppCCustomerSlugTrackingIndexRouteImport
      parentRoute: typeof AppCCustomerSlugTrackingRoute
    }
    '/app/c/$customerSlug/requests/': {
      id: '/app/c/$customerSlug/requests/'
      path: '/requests'
      fullPath: '/app/c/$customerSlug/requests/'
      preLoaderRoute: typeof AppCCustomerSlugRequestsIndexRouteImport
      parentRoute: typeof AppCCustomerSlugRoute
    }
    '/app/c/$customerSlug/materials/': {
      id: '/app/c/$customerSlug/materials/'
      path: '/'
      fullPath: '/app/c/$customerSlug/materials/'
      preLoaderRoute: typeof AppCCustomerSlugMaterialsIndexRouteImport
      parentRoute: typeof AppCCustomerSlugMaterialsRoute
    }
    '/app/c/$customerSlug/locations/': {
      id: '/app/c/$customerSlug/locations/'
      path: '/'
      fullPath: '/app/c/$customerSlug/locations/'
      preLoaderRoute: typeof AppCCustomerSlugLocationsIndexRouteImport
      parentRoute: typeof AppCCustomerSlugLocationsRoute
    }
    '/app/c/$customerSlug/bikes/': {
      id: '/app/c/$customerSlug/bikes/'
      path: '/'
      fullPath: '/app/c/$customerSlug/bikes/'
      preLoaderRoute: typeof AppCCustomerSlugBikesIndexRouteImport
      parentRoute: typeof AppCCustomerSlugBikesRoute
    }
    '/app/c/$customerSlug/bike-models/': {
      id: '/app/c/$customerSlug/bike-models/'
      path: '/'
      fullPath: '/app/c/$customerSlug/bike-models/'
      preLoaderRoute: typeof AppCCustomerSlugBikeModelsIndexRouteImport
      parentRoute: typeof AppCCustomerSlugBikeModelsRoute
    }
    '/app/admin/materials/$id/': {
      id: '/app/admin/materials/$id/'
      path: '/'
      fullPath: '/app/admin/materials/$id/'
      preLoaderRoute: typeof AppAdminMaterialsIdIndexRouteImport
      parentRoute: typeof AppAdminMaterialsIdRoute
    }
    '/app/admin/fsm/transitions/': {
      id: '/app/admin/fsm/transitions/'
      path: '/transitions'
      fullPath: '/app/admin/fsm/transitions/'
      preLoaderRoute: typeof AppAdminFsmTransitionsIndexRouteImport
      parentRoute: typeof AppAdminFsmRoute
    }
    '/app/admin/fsm/states/': {
      id: '/app/admin/fsm/states/'
      path: '/states'
      fullPath: '/app/admin/fsm/states/'
      preLoaderRoute: typeof AppAdminFsmStatesIndexRouteImport
      parentRoute: typeof AppAdminFsmRoute
    }
    '/app/admin/fsm/entity-types/': {
      id: '/app/admin/fsm/entity-types/'
      path: '/entity-types'
      fullPath: '/app/admin/fsm/entity-types/'
      preLoaderRoute: typeof AppAdminFsmEntityTypesIndexRouteImport
      parentRoute: typeof AppAdminFsmRoute
    }
    '/app/admin/fsm/entities/': {
      id: '/app/admin/fsm/entities/'
      path: '/entities'
      fullPath: '/app/admin/fsm/entities/'
      preLoaderRoute: typeof AppAdminFsmEntitiesIndexRouteImport
      parentRoute: typeof AppAdminFsmRoute
    }
    '/app/admin/fsm/document-types/': {
      id: '/app/admin/fsm/document-types/'
      path: '/document-types'
      fullPath: '/app/admin/fsm/document-types/'
      preLoaderRoute: typeof AppAdminFsmDocumentTypesIndexRouteImport
      parentRoute: typeof AppAdminFsmRoute
    }
    '/app/admin/fsm-workflows/transitions/': {
      id: '/app/admin/fsm-workflows/transitions/'
      path: '/transitions'
      fullPath: '/app/admin/fsm-workflows/transitions/'
      preLoaderRoute: typeof AppAdminFsmWorkflowsTransitionsIndexRouteImport
      parentRoute: typeof AppAdminFsmWorkflowsRoute
    }
    '/app/admin/fsm-workflows/states/': {
      id: '/app/admin/fsm-workflows/states/'
      path: '/states'
      fullPath: '/app/admin/fsm-workflows/states/'
      preLoaderRoute: typeof AppAdminFsmWorkflowsStatesIndexRouteImport
      parentRoute: typeof AppAdminFsmWorkflowsRoute
    }
    '/app/admin/fsm-workflows/entity-types/': {
      id: '/app/admin/fsm-workflows/entity-types/'
      path: '/entity-types'
      fullPath: '/app/admin/fsm-workflows/entity-types/'
      preLoaderRoute: typeof AppAdminFsmWorkflowsEntityTypesIndexRouteImport
      parentRoute: typeof AppAdminFsmWorkflowsRoute
    }
    '/app/admin/fsm-workflows/entities/': {
      id: '/app/admin/fsm-workflows/entities/'
      path: '/entities'
      fullPath: '/app/admin/fsm-workflows/entities/'
      preLoaderRoute: typeof AppAdminFsmWorkflowsEntitiesIndexRouteImport
      parentRoute: typeof AppAdminFsmWorkflowsRoute
    }
    '/app/admin/fsm-workflows/document-types/': {
      id: '/app/admin/fsm-workflows/document-types/'
      path: '/document-types'
      fullPath: '/app/admin/fsm-workflows/document-types/'
      preLoaderRoute: typeof AppAdminFsmWorkflowsDocumentTypesIndexRouteImport
      parentRoute: typeof AppAdminFsmWorkflowsRoute
    }
    '/app/admin/bike-models/$id/': {
      id: '/app/admin/bike-models/$id/'
      path: '/'
      fullPath: '/app/admin/bike-models/$id/'
      preLoaderRoute: typeof AppAdminBikeModelsIdIndexRouteImport
      parentRoute: typeof AppAdminBikeModelsIdRoute
    }
    '/app/c/$customerSlug/requests/new': {
      id: '/app/c/$customerSlug/requests/new'
      path: '/requests/new'
      fullPath: '/app/c/$customerSlug/requests/new'
      preLoaderRoute: typeof AppCCustomerSlugRequestsNewRouteImport
      parentRoute: typeof AppCCustomerSlugRoute
    }
    '/app/c/$customerSlug/requests/$id': {
      id: '/app/c/$customerSlug/requests/$id'
      path: '/requests/$id'
      fullPath: '/app/c/$customerSlug/requests/$id'
      preLoaderRoute: typeof AppCCustomerSlugRequestsIdRouteImport
      parentRoute: typeof AppCCustomerSlugRoute
    }
    '/app/c/$customerSlug/reporting/materials-budget': {
      id: '/app/c/$customerSlug/reporting/materials-budget'
      path: '/reporting/materials-budget'
      fullPath: '/app/c/$customerSlug/reporting/materials-budget'
      preLoaderRoute: typeof AppCCustomerSlugReportingMaterialsBudgetRouteImport
      parentRoute: typeof AppCCustomerSlugRoute
    }
    '/app/c/$customerSlug/reporting/kpi-ops': {
      id: '/app/c/$customerSlug/reporting/kpi-ops'
      path: '/reporting/kpi-ops'
      fullPath: '/app/c/$customerSlug/reporting/kpi-ops'
      preLoaderRoute: typeof AppCCustomerSlugReportingKpiOpsRouteImport
      parentRoute: typeof AppCCustomerSlugRoute
    }
    '/app/c/$customerSlug/materials/new': {
      id: '/app/c/$customerSlug/materials/new'
      path: '/new'
      fullPath: '/app/c/$customerSlug/materials/new'
      preLoaderRoute: typeof AppCCustomerSlugMaterialsNewRouteImport
      parentRoute: typeof AppCCustomerSlugMaterialsRoute
    }
    '/app/c/$customerSlug/materials/import-relations': {
      id: '/app/c/$customerSlug/materials/import-relations'
      path: '/import-relations'
      fullPath: '/app/c/$customerSlug/materials/import-relations'
      preLoaderRoute: typeof AppCCustomerSlugMaterialsImportRelationsRouteImport
      parentRoute: typeof AppCCustomerSlugMaterialsRoute
    }
    '/app/c/$customerSlug/materials/import': {
      id: '/app/c/$customerSlug/materials/import'
      path: '/import'
      fullPath: '/app/c/$customerSlug/materials/import'
      preLoaderRoute: typeof AppCCustomerSlugMaterialsImportRouteImport
      parentRoute: typeof AppCCustomerSlugMaterialsRoute
    }
    '/app/c/$customerSlug/materials/$id': {
      id: '/app/c/$customerSlug/materials/$id'
      path: '/$id'
      fullPath: '/app/c/$customerSlug/materials/$id'
      preLoaderRoute: typeof AppCCustomerSlugMaterialsIdRouteImport
      parentRoute: typeof AppCCustomerSlugMaterialsRoute
    }
    '/app/c/$customerSlug/locations/new': {
      id: '/app/c/$customerSlug/locations/new'
      path: '/new'
      fullPath: '/app/c/$customerSlug/locations/new'
      preLoaderRoute: typeof AppCCustomerSlugLocationsNewRouteImport
      parentRoute: typeof AppCCustomerSlugLocationsRoute
    }
    '/app/c/$customerSlug/locations/$id': {
      id: '/app/c/$customerSlug/locations/$id'
      path: '/$id'
      fullPath: '/app/c/$customerSlug/locations/$id'
      preLoaderRoute: typeof AppCCustomerSlugLocationsIdRouteImport
      parentRoute: typeof AppCCustomerSlugLocationsRoute
    }
    '/app/c/$customerSlug/d/$docTypeSlug': {
      id: '/app/c/$customerSlug/d/$docTypeSlug'
      path: '/d/$docTypeSlug'
      fullPath: '/app/c/$customerSlug/d/$docTypeSlug'
      preLoaderRoute: typeof AppCCustomerSlugDDocTypeSlugRouteImport
      parentRoute: typeof AppCCustomerSlugRoute
    }
    '/app/c/$customerSlug/bikes/new': {
      id: '/app/c/$customerSlug/bikes/new'
      path: '/new'
      fullPath: '/app/c/$customerSlug/bikes/new'
      preLoaderRoute: typeof AppCCustomerSlugBikesNewRouteImport
      parentRoute: typeof AppCCustomerSlugBikesRoute
    }
    '/app/c/$customerSlug/bikes/$id': {
      id: '/app/c/$customerSlug/bikes/$id'
      path: '/$id'
      fullPath: '/app/c/$customerSlug/bikes/$id'
      preLoaderRoute: typeof AppCCustomerSlugBikesIdRouteImport
      parentRoute: typeof AppCCustomerSlugBikesRoute
    }
    '/app/c/$customerSlug/bike-models/new': {
      id: '/app/c/$customerSlug/bike-models/new'
      path: '/new'
      fullPath: '/app/c/$customerSlug/bike-models/new'
      preLoaderRoute: typeof AppCCustomerSlugBikeModelsNewRouteImport
      parentRoute: typeof AppCCustomerSlugBikeModelsRoute
    }
    '/app/c/$customerSlug/bike-models/$id': {
      id: '/app/c/$customerSlug/bike-models/$id'
      path: '/$id'
      fullPath: '/app/c/$customerSlug/bike-models/$id'
      preLoaderRoute: typeof AppCCustomerSlugBikeModelsIdRouteImport
      parentRoute: typeof AppCCustomerSlugBikeModelsRoute
    }
    '/app/admin/materials/$id/bike-models': {
      id: '/app/admin/materials/$id/bike-models'
      path: '/bike-models'
      fullPath: '/app/admin/materials/$id/bike-models'
      preLoaderRoute: typeof AppAdminMaterialsIdBikeModelsRouteImport
      parentRoute: typeof AppAdminMaterialsIdRoute
    }
    '/app/admin/fsm/transitions/$id': {
      id: '/app/admin/fsm/transitions/$id'
      path: '/transitions/$id'
      fullPath: '/app/admin/fsm/transitions/$id'
      preLoaderRoute: typeof AppAdminFsmTransitionsIdRouteImport
      parentRoute: typeof AppAdminFsmRoute
    }
    '/app/admin/fsm/states/$id': {
      id: '/app/admin/fsm/states/$id'
      path: '/states/$id'
      fullPath: '/app/admin/fsm/states/$id'
      preLoaderRoute: typeof AppAdminFsmStatesIdRouteImport
      parentRoute: typeof AppAdminFsmRoute
    }
    '/app/admin/fsm/entity-types/$id': {
      id: '/app/admin/fsm/entity-types/$id'
      path: '/entity-types/$id'
      fullPath: '/app/admin/fsm/entity-types/$id'
      preLoaderRoute: typeof AppAdminFsmEntityTypesIdRouteImport
      parentRoute: typeof AppAdminFsmRoute
    }
    '/app/admin/fsm/entities/$id': {
      id: '/app/admin/fsm/entities/$id'
      path: '/entities/$id'
      fullPath: '/app/admin/fsm/entities/$id'
      preLoaderRoute: typeof AppAdminFsmEntitiesIdRouteImport
      parentRoute: typeof AppAdminFsmRoute
    }
    '/app/admin/fsm/document-types/$id': {
      id: '/app/admin/fsm/document-types/$id'
      path: '/document-types/$id'
      fullPath: '/app/admin/fsm/document-types/$id'
      preLoaderRoute: typeof AppAdminFsmDocumentTypesIdRouteImport
      parentRoute: typeof AppAdminFsmRoute
    }
    '/app/admin/fsm-workflows/transitions/$id': {
      id: '/app/admin/fsm-workflows/transitions/$id'
      path: '/transitions/$id'
      fullPath: '/app/admin/fsm-workflows/transitions/$id'
      preLoaderRoute: typeof AppAdminFsmWorkflowsTransitionsIdRouteImport
      parentRoute: typeof AppAdminFsmWorkflowsRoute
    }
    '/app/admin/fsm-workflows/states/$id': {
      id: '/app/admin/fsm-workflows/states/$id'
      path: '/states/$id'
      fullPath: '/app/admin/fsm-workflows/states/$id'
      preLoaderRoute: typeof AppAdminFsmWorkflowsStatesIdRouteImport
      parentRoute: typeof AppAdminFsmWorkflowsRoute
    }
    '/app/admin/fsm-workflows/entity-types/$id': {
      id: '/app/admin/fsm-workflows/entity-types/$id'
      path: '/entity-types/$id'
      fullPath: '/app/admin/fsm-workflows/entity-types/$id'
      preLoaderRoute: typeof AppAdminFsmWorkflowsEntityTypesIdRouteImport
      parentRoute: typeof AppAdminFsmWorkflowsRoute
    }
    '/app/admin/fsm-workflows/entities/$id': {
      id: '/app/admin/fsm-workflows/entities/$id'
      path: '/entities/$id'
      fullPath: '/app/admin/fsm-workflows/entities/$id'
      preLoaderRoute: typeof AppAdminFsmWorkflowsEntitiesIdRouteImport
      parentRoute: typeof AppAdminFsmWorkflowsRoute
    }
    '/app/admin/fsm-workflows/document-types/$id': {
      id: '/app/admin/fsm-workflows/document-types/$id'
      path: '/document-types/$id'
      fullPath: '/app/admin/fsm-workflows/document-types/$id'
      preLoaderRoute: typeof AppAdminFsmWorkflowsDocumentTypesIdRouteImport
      parentRoute: typeof AppAdminFsmWorkflowsRoute
    }
    '/app/admin/bike-models/$id/materials': {
      id: '/app/admin/bike-models/$id/materials'
      path: '/materials'
      fullPath: '/app/admin/bike-models/$id/materials'
      preLoaderRoute: typeof AppAdminBikeModelsIdMaterialsRouteImport
      parentRoute: typeof AppAdminBikeModelsIdRoute
    }
    '/app/c/$customerSlug/reporting/materials-budget/': {
      id: '/app/c/$customerSlug/reporting/materials-budget/'
      path: '/'
      fullPath: '/app/c/$customerSlug/reporting/materials-budget/'
      preLoaderRoute: typeof AppCCustomerSlugReportingMaterialsBudgetIndexRouteImport
      parentRoute: typeof AppCCustomerSlugReportingMaterialsBudgetRoute
    }
    '/app/c/$customerSlug/reporting/kpi-ops/': {
      id: '/app/c/$customerSlug/reporting/kpi-ops/'
      path: '/'
      fullPath: '/app/c/$customerSlug/reporting/kpi-ops/'
      preLoaderRoute: typeof AppCCustomerSlugReportingKpiOpsIndexRouteImport
      parentRoute: typeof AppCCustomerSlugReportingKpiOpsRoute
    }
    '/app/c/$customerSlug/materials/$id/': {
      id: '/app/c/$customerSlug/materials/$id/'
      path: '/'
      fullPath: '/app/c/$customerSlug/materials/$id/'
      preLoaderRoute: typeof AppCCustomerSlugMaterialsIdIndexRouteImport
      parentRoute: typeof AppCCustomerSlugMaterialsIdRoute
    }
    '/app/c/$customerSlug/d/$docTypeSlug/': {
      id: '/app/c/$customerSlug/d/$docTypeSlug/'
      path: '/'
      fullPath: '/app/c/$customerSlug/d/$docTypeSlug/'
      preLoaderRoute: typeof AppCCustomerSlugDDocTypeSlugIndexRouteImport
      parentRoute: typeof AppCCustomerSlugDDocTypeSlugRoute
    }
    '/app/c/$customerSlug/bike-models/$id/': {
      id: '/app/c/$customerSlug/bike-models/$id/'
      path: '/'
      fullPath: '/app/c/$customerSlug/bike-models/$id/'
      preLoaderRoute: typeof AppCCustomerSlugBikeModelsIdIndexRouteImport
      parentRoute: typeof AppCCustomerSlugBikeModelsIdRoute
    }
    '/app/c/$customerSlug/materials/$id/bike-models': {
      id: '/app/c/$customerSlug/materials/$id/bike-models'
      path: '/bike-models'
      fullPath: '/app/c/$customerSlug/materials/$id/bike-models'
      preLoaderRoute: typeof AppCCustomerSlugMaterialsIdBikeModelsRouteImport
      parentRoute: typeof AppCCustomerSlugMaterialsIdRoute
    }
    '/app/c/$customerSlug/d/$docTypeSlug/$documentId': {
      id: '/app/c/$customerSlug/d/$docTypeSlug/$documentId'
      path: '/$documentId'
      fullPath: '/app/c/$customerSlug/d/$docTypeSlug/$documentId'
      preLoaderRoute: typeof AppCCustomerSlugDDocTypeSlugDocumentIdRouteImport
      parentRoute: typeof AppCCustomerSlugDDocTypeSlugRoute
    }
    '/app/c/$customerSlug/bike-models/$id/materials': {
      id: '/app/c/$customerSlug/bike-models/$id/materials'
      path: '/materials'
      fullPath: '/app/c/$customerSlug/bike-models/$id/materials'
      preLoaderRoute: typeof AppCCustomerSlugBikeModelsIdMaterialsRouteImport
      parentRoute: typeof AppCCustomerSlugBikeModelsIdRoute
    }
  }
}

interface PublicRouteChildren {
  PublicCompleteRegistrationRoute: typeof PublicCompleteRegistrationRoute
  PublicLoginRoute: typeof PublicLoginRoute
  PublicPrivacyRoute: typeof PublicPrivacyRoute
  PublicRegisterRoute: typeof PublicRegisterRoute
  PublicRepairRoute: typeof PublicRepairRoute
  PublicIndexRoute: typeof PublicIndexRoute
}

const PublicRouteChildren: PublicRouteChildren = {
  PublicCompleteRegistrationRoute: PublicCompleteRegistrationRoute,
  PublicLoginRoute: PublicLoginRoute,
  PublicPrivacyRoute: PublicPrivacyRoute,
  PublicRegisterRoute: PublicRegisterRoute,
  PublicRepairRoute: PublicRepairRoute,
  PublicIndexRoute: PublicIndexRoute,
}

const PublicRouteWithChildren =
  PublicRoute._addFileChildren(PublicRouteChildren)

interface AppCustomerRouteChildren {
  AppCustomerIndexRoute: typeof AppCustomerIndexRoute
  AppCustomerRequestsIdRoute: typeof AppCustomerRequestsIdRoute
  AppCustomerRequestsNewRoute: typeof AppCustomerRequestsNewRoute
  AppCustomerRequestsIndexRoute: typeof AppCustomerRequestsIndexRoute
}

const AppCustomerRouteChildren: AppCustomerRouteChildren = {
  AppCustomerIndexRoute: AppCustomerIndexRoute,
  AppCustomerRequestsIdRoute: AppCustomerRequestsIdRoute,
  AppCustomerRequestsNewRoute: AppCustomerRequestsNewRoute,
  AppCustomerRequestsIndexRoute: AppCustomerRequestsIndexRoute,
}

const AppCustomerRouteWithChildren = AppCustomerRoute._addFileChildren(
  AppCustomerRouteChildren,
)

interface AppSettingsCustomersRouteChildren {
  AppSettingsCustomersIndexRoute: typeof AppSettingsCustomersIndexRoute
}

const AppSettingsCustomersRouteChildren: AppSettingsCustomersRouteChildren = {
  AppSettingsCustomersIndexRoute: AppSettingsCustomersIndexRoute,
}

const AppSettingsCustomersRouteWithChildren =
  AppSettingsCustomersRoute._addFileChildren(AppSettingsCustomersRouteChildren)

interface AppSettingsRouteChildren {
  AppSettingsCustomersRoute: typeof AppSettingsCustomersRouteWithChildren
  AppSettingsFsmWorkflowsRoute: typeof AppSettingsFsmWorkflowsRoute
  AppSettingsIndexRoute: typeof AppSettingsIndexRoute
}

const AppSettingsRouteChildren: AppSettingsRouteChildren = {
  AppSettingsCustomersRoute: AppSettingsCustomersRouteWithChildren,
  AppSettingsFsmWorkflowsRoute: AppSettingsFsmWorkflowsRoute,
  AppSettingsIndexRoute: AppSettingsIndexRoute,
}

const AppSettingsRouteWithChildren = AppSettingsRoute._addFileChildren(
  AppSettingsRouteChildren,
)

interface AppAdminBikeModelsIdRouteChildren {
  AppAdminBikeModelsIdMaterialsRoute: typeof AppAdminBikeModelsIdMaterialsRoute
  AppAdminBikeModelsIdIndexRoute: typeof AppAdminBikeModelsIdIndexRoute
}

const AppAdminBikeModelsIdRouteChildren: AppAdminBikeModelsIdRouteChildren = {
  AppAdminBikeModelsIdMaterialsRoute: AppAdminBikeModelsIdMaterialsRoute,
  AppAdminBikeModelsIdIndexRoute: AppAdminBikeModelsIdIndexRoute,
}

const AppAdminBikeModelsIdRouteWithChildren =
  AppAdminBikeModelsIdRoute._addFileChildren(AppAdminBikeModelsIdRouteChildren)

interface AppAdminBikeModelsRouteChildren {
  AppAdminBikeModelsIdRoute: typeof AppAdminBikeModelsIdRouteWithChildren
  AppAdminBikeModelsNewRoute: typeof AppAdminBikeModelsNewRoute
  AppAdminBikeModelsIndexRoute: typeof AppAdminBikeModelsIndexRoute
}

const AppAdminBikeModelsRouteChildren: AppAdminBikeModelsRouteChildren = {
  AppAdminBikeModelsIdRoute: AppAdminBikeModelsIdRouteWithChildren,
  AppAdminBikeModelsNewRoute: AppAdminBikeModelsNewRoute,
  AppAdminBikeModelsIndexRoute: AppAdminBikeModelsIndexRoute,
}

const AppAdminBikeModelsRouteWithChildren =
  AppAdminBikeModelsRoute._addFileChildren(AppAdminBikeModelsRouteChildren)

interface AppAdminBikesRouteChildren {
  AppAdminBikesIdRoute: typeof AppAdminBikesIdRoute
  AppAdminBikesNewRoute: typeof AppAdminBikesNewRoute
  AppAdminBikesIndexRoute: typeof AppAdminBikesIndexRoute
}

const AppAdminBikesRouteChildren: AppAdminBikesRouteChildren = {
  AppAdminBikesIdRoute: AppAdminBikesIdRoute,
  AppAdminBikesNewRoute: AppAdminBikesNewRoute,
  AppAdminBikesIndexRoute: AppAdminBikesIndexRoute,
}

const AppAdminBikesRouteWithChildren = AppAdminBikesRoute._addFileChildren(
  AppAdminBikesRouteChildren,
)

interface AppAdminCustomersRouteChildren {
  AppAdminCustomersIndexRoute: typeof AppAdminCustomersIndexRoute
}

const AppAdminCustomersRouteChildren: AppAdminCustomersRouteChildren = {
  AppAdminCustomersIndexRoute: AppAdminCustomersIndexRoute,
}

const AppAdminCustomersRouteWithChildren =
  AppAdminCustomersRoute._addFileChildren(AppAdminCustomersRouteChildren)

interface AppAdminDevicesRouteChildren {
  AppAdminDevicesIdRoute: typeof AppAdminDevicesIdRoute
  AppAdminDevicesNewRoute: typeof AppAdminDevicesNewRoute
  AppAdminDevicesIndexRoute: typeof AppAdminDevicesIndexRoute
}

const AppAdminDevicesRouteChildren: AppAdminDevicesRouteChildren = {
  AppAdminDevicesIdRoute: AppAdminDevicesIdRoute,
  AppAdminDevicesNewRoute: AppAdminDevicesNewRoute,
  AppAdminDevicesIndexRoute: AppAdminDevicesIndexRoute,
}

const AppAdminDevicesRouteWithChildren = AppAdminDevicesRoute._addFileChildren(
  AppAdminDevicesRouteChildren,
)

interface AppAdminFsmRouteChildren {
  AppAdminFsmIndexRoute: typeof AppAdminFsmIndexRoute
  AppAdminFsmDocumentTypesIdRoute: typeof AppAdminFsmDocumentTypesIdRoute
  AppAdminFsmEntitiesIdRoute: typeof AppAdminFsmEntitiesIdRoute
  AppAdminFsmEntityTypesIdRoute: typeof AppAdminFsmEntityTypesIdRoute
  AppAdminFsmStatesIdRoute: typeof AppAdminFsmStatesIdRoute
  AppAdminFsmTransitionsIdRoute: typeof AppAdminFsmTransitionsIdRoute
  AppAdminFsmDocumentTypesIndexRoute: typeof AppAdminFsmDocumentTypesIndexRoute
  AppAdminFsmEntitiesIndexRoute: typeof AppAdminFsmEntitiesIndexRoute
  AppAdminFsmEntityTypesIndexRoute: typeof AppAdminFsmEntityTypesIndexRoute
  AppAdminFsmStatesIndexRoute: typeof AppAdminFsmStatesIndexRoute
  AppAdminFsmTransitionsIndexRoute: typeof AppAdminFsmTransitionsIndexRoute
  AppAdminFsmWorkflowsIndexLazyRoute: typeof AppAdminFsmWorkflowsIndexLazyRoute
}

const AppAdminFsmRouteChildren: AppAdminFsmRouteChildren = {
  AppAdminFsmIndexRoute: AppAdminFsmIndexRoute,
  AppAdminFsmDocumentTypesIdRoute: AppAdminFsmDocumentTypesIdRoute,
  AppAdminFsmEntitiesIdRoute: AppAdminFsmEntitiesIdRoute,
  AppAdminFsmEntityTypesIdRoute: AppAdminFsmEntityTypesIdRoute,
  AppAdminFsmStatesIdRoute: AppAdminFsmStatesIdRoute,
  AppAdminFsmTransitionsIdRoute: AppAdminFsmTransitionsIdRoute,
  AppAdminFsmDocumentTypesIndexRoute: AppAdminFsmDocumentTypesIndexRoute,
  AppAdminFsmEntitiesIndexRoute: AppAdminFsmEntitiesIndexRoute,
  AppAdminFsmEntityTypesIndexRoute: AppAdminFsmEntityTypesIndexRoute,
  AppAdminFsmStatesIndexRoute: AppAdminFsmStatesIndexRoute,
  AppAdminFsmTransitionsIndexRoute: AppAdminFsmTransitionsIndexRoute,
  AppAdminFsmWorkflowsIndexLazyRoute: AppAdminFsmWorkflowsIndexLazyRoute,
}

const AppAdminFsmRouteWithChildren = AppAdminFsmRoute._addFileChildren(
  AppAdminFsmRouteChildren,
)

interface AppAdminFsmWorkflowsRouteChildren {
  AppAdminFsmWorkflowsIndexRoute: typeof AppAdminFsmWorkflowsIndexRoute
  AppAdminFsmWorkflowsDocumentTypesIdRoute: typeof AppAdminFsmWorkflowsDocumentTypesIdRoute
  AppAdminFsmWorkflowsEntitiesIdRoute: typeof AppAdminFsmWorkflowsEntitiesIdRoute
  AppAdminFsmWorkflowsEntityTypesIdRoute: typeof AppAdminFsmWorkflowsEntityTypesIdRoute
  AppAdminFsmWorkflowsStatesIdRoute: typeof AppAdminFsmWorkflowsStatesIdRoute
  AppAdminFsmWorkflowsTransitionsIdRoute: typeof AppAdminFsmWorkflowsTransitionsIdRoute
  AppAdminFsmWorkflowsDocumentTypesIndexRoute: typeof AppAdminFsmWorkflowsDocumentTypesIndexRoute
  AppAdminFsmWorkflowsEntitiesIndexRoute: typeof AppAdminFsmWorkflowsEntitiesIndexRoute
  AppAdminFsmWorkflowsEntityTypesIndexRoute: typeof AppAdminFsmWorkflowsEntityTypesIndexRoute
  AppAdminFsmWorkflowsStatesIndexRoute: typeof AppAdminFsmWorkflowsStatesIndexRoute
  AppAdminFsmWorkflowsTransitionsIndexRoute: typeof AppAdminFsmWorkflowsTransitionsIndexRoute
  AppAdminFsmWorkflowsWorkflowsIndexLazyRoute: typeof AppAdminFsmWorkflowsWorkflowsIndexLazyRoute
}

const AppAdminFsmWorkflowsRouteChildren: AppAdminFsmWorkflowsRouteChildren = {
  AppAdminFsmWorkflowsIndexRoute: AppAdminFsmWorkflowsIndexRoute,
  AppAdminFsmWorkflowsDocumentTypesIdRoute:
    AppAdminFsmWorkflowsDocumentTypesIdRoute,
  AppAdminFsmWorkflowsEntitiesIdRoute: AppAdminFsmWorkflowsEntitiesIdRoute,
  AppAdminFsmWorkflowsEntityTypesIdRoute:
    AppAdminFsmWorkflowsEntityTypesIdRoute,
  AppAdminFsmWorkflowsStatesIdRoute: AppAdminFsmWorkflowsStatesIdRoute,
  AppAdminFsmWorkflowsTransitionsIdRoute:
    AppAdminFsmWorkflowsTransitionsIdRoute,
  AppAdminFsmWorkflowsDocumentTypesIndexRoute:
    AppAdminFsmWorkflowsDocumentTypesIndexRoute,
  AppAdminFsmWorkflowsEntitiesIndexRoute:
    AppAdminFsmWorkflowsEntitiesIndexRoute,
  AppAdminFsmWorkflowsEntityTypesIndexRoute:
    AppAdminFsmWorkflowsEntityTypesIndexRoute,
  AppAdminFsmWorkflowsStatesIndexRoute: AppAdminFsmWorkflowsStatesIndexRoute,
  AppAdminFsmWorkflowsTransitionsIndexRoute:
    AppAdminFsmWorkflowsTransitionsIndexRoute,
  AppAdminFsmWorkflowsWorkflowsIndexLazyRoute:
    AppAdminFsmWorkflowsWorkflowsIndexLazyRoute,
}

const AppAdminFsmWorkflowsRouteWithChildren =
  AppAdminFsmWorkflowsRoute._addFileChildren(AppAdminFsmWorkflowsRouteChildren)

interface AppAdminKpisRouteChildren {
  AppAdminKpisIndexRoute: typeof AppAdminKpisIndexRoute
}

const AppAdminKpisRouteChildren: AppAdminKpisRouteChildren = {
  AppAdminKpisIndexRoute: AppAdminKpisIndexRoute,
}

const AppAdminKpisRouteWithChildren = AppAdminKpisRoute._addFileChildren(
  AppAdminKpisRouteChildren,
)

interface AppAdminLocationsRouteChildren {
  AppAdminLocationsIdRoute: typeof AppAdminLocationsIdRoute
  AppAdminLocationsNewRoute: typeof AppAdminLocationsNewRoute
  AppAdminLocationsIndexRoute: typeof AppAdminLocationsIndexRoute
}

const AppAdminLocationsRouteChildren: AppAdminLocationsRouteChildren = {
  AppAdminLocationsIdRoute: AppAdminLocationsIdRoute,
  AppAdminLocationsNewRoute: AppAdminLocationsNewRoute,
  AppAdminLocationsIndexRoute: AppAdminLocationsIndexRoute,
}

const AppAdminLocationsRouteWithChildren =
  AppAdminLocationsRoute._addFileChildren(AppAdminLocationsRouteChildren)

interface AppAdminMapRouteChildren {
  AppAdminMapIndexRoute: typeof AppAdminMapIndexRoute
}

const AppAdminMapRouteChildren: AppAdminMapRouteChildren = {
  AppAdminMapIndexRoute: AppAdminMapIndexRoute,
}

const AppAdminMapRouteWithChildren = AppAdminMapRoute._addFileChildren(
  AppAdminMapRouteChildren,
)

interface AppAdminMaterialsIdRouteChildren {
  AppAdminMaterialsIdBikeModelsRoute: typeof AppAdminMaterialsIdBikeModelsRoute
  AppAdminMaterialsIdIndexRoute: typeof AppAdminMaterialsIdIndexRoute
}

const AppAdminMaterialsIdRouteChildren: AppAdminMaterialsIdRouteChildren = {
  AppAdminMaterialsIdBikeModelsRoute: AppAdminMaterialsIdBikeModelsRoute,
  AppAdminMaterialsIdIndexRoute: AppAdminMaterialsIdIndexRoute,
}

const AppAdminMaterialsIdRouteWithChildren =
  AppAdminMaterialsIdRoute._addFileChildren(AppAdminMaterialsIdRouteChildren)

interface AppAdminMaterialsRouteChildren {
  AppAdminMaterialsIdRoute: typeof AppAdminMaterialsIdRouteWithChildren
  AppAdminMaterialsImportRoute: typeof AppAdminMaterialsImportRoute
  AppAdminMaterialsImportRelationsRoute: typeof AppAdminMaterialsImportRelationsRoute
  AppAdminMaterialsNewRoute: typeof AppAdminMaterialsNewRoute
  AppAdminMaterialsIndexRoute: typeof AppAdminMaterialsIndexRoute
}

const AppAdminMaterialsRouteChildren: AppAdminMaterialsRouteChildren = {
  AppAdminMaterialsIdRoute: AppAdminMaterialsIdRouteWithChildren,
  AppAdminMaterialsImportRoute: AppAdminMaterialsImportRoute,
  AppAdminMaterialsImportRelationsRoute: AppAdminMaterialsImportRelationsRoute,
  AppAdminMaterialsNewRoute: AppAdminMaterialsNewRoute,
  AppAdminMaterialsIndexRoute: AppAdminMaterialsIndexRoute,
}

const AppAdminMaterialsRouteWithChildren =
  AppAdminMaterialsRoute._addFileChildren(AppAdminMaterialsRouteChildren)

interface AppAdminNotificationChannelsRouteChildren {
  AppAdminNotificationChannelsIndexRoute: typeof AppAdminNotificationChannelsIndexRoute
}

const AppAdminNotificationChannelsRouteChildren: AppAdminNotificationChannelsRouteChildren =
  {
    AppAdminNotificationChannelsIndexRoute:
      AppAdminNotificationChannelsIndexRoute,
  }

const AppAdminNotificationChannelsRouteWithChildren =
  AppAdminNotificationChannelsRoute._addFileChildren(
    AppAdminNotificationChannelsRouteChildren,
  )

interface AppAdminRolesRouteChildren {
  AppAdminRolesIdRoute: typeof AppAdminRolesIdRoute
  AppAdminRolesIndexRoute: typeof AppAdminRolesIndexRoute
}

const AppAdminRolesRouteChildren: AppAdminRolesRouteChildren = {
  AppAdminRolesIdRoute: AppAdminRolesIdRoute,
  AppAdminRolesIndexRoute: AppAdminRolesIndexRoute,
}

const AppAdminRolesRouteWithChildren = AppAdminRolesRoute._addFileChildren(
  AppAdminRolesRouteChildren,
)

interface AppAdminStationsRouteChildren {
  AppAdminStationsIdRoute: typeof AppAdminStationsIdRoute
  AppAdminStationsNewRoute: typeof AppAdminStationsNewRoute
  AppAdminStationsIndexRoute: typeof AppAdminStationsIndexRoute
}

const AppAdminStationsRouteChildren: AppAdminStationsRouteChildren = {
  AppAdminStationsIdRoute: AppAdminStationsIdRoute,
  AppAdminStationsNewRoute: AppAdminStationsNewRoute,
  AppAdminStationsIndexRoute: AppAdminStationsIndexRoute,
}

const AppAdminStationsRouteWithChildren =
  AppAdminStationsRoute._addFileChildren(AppAdminStationsRouteChildren)

interface AppAdminUsersRouteChildren {
  AppAdminUsersIdRoute: typeof AppAdminUsersIdRoute
  AppAdminUsersInviteRoute: typeof AppAdminUsersInviteRoute
  AppAdminUsersIndexRoute: typeof AppAdminUsersIndexRoute
}

const AppAdminUsersRouteChildren: AppAdminUsersRouteChildren = {
  AppAdminUsersIdRoute: AppAdminUsersIdRoute,
  AppAdminUsersInviteRoute: AppAdminUsersInviteRoute,
  AppAdminUsersIndexRoute: AppAdminUsersIndexRoute,
}

const AppAdminUsersRouteWithChildren = AppAdminUsersRoute._addFileChildren(
  AppAdminUsersRouteChildren,
)

interface AppCCustomerSlugBikeModelsIdRouteChildren {
  AppCCustomerSlugBikeModelsIdMaterialsRoute: typeof AppCCustomerSlugBikeModelsIdMaterialsRoute
  AppCCustomerSlugBikeModelsIdIndexRoute: typeof AppCCustomerSlugBikeModelsIdIndexRoute
}

const AppCCustomerSlugBikeModelsIdRouteChildren: AppCCustomerSlugBikeModelsIdRouteChildren =
  {
    AppCCustomerSlugBikeModelsIdMaterialsRoute:
      AppCCustomerSlugBikeModelsIdMaterialsRoute,
    AppCCustomerSlugBikeModelsIdIndexRoute:
      AppCCustomerSlugBikeModelsIdIndexRoute,
  }

const AppCCustomerSlugBikeModelsIdRouteWithChildren =
  AppCCustomerSlugBikeModelsIdRoute._addFileChildren(
    AppCCustomerSlugBikeModelsIdRouteChildren,
  )

interface AppCCustomerSlugBikeModelsRouteChildren {
  AppCCustomerSlugBikeModelsIdRoute: typeof AppCCustomerSlugBikeModelsIdRouteWithChildren
  AppCCustomerSlugBikeModelsNewRoute: typeof AppCCustomerSlugBikeModelsNewRoute
  AppCCustomerSlugBikeModelsIndexRoute: typeof AppCCustomerSlugBikeModelsIndexRoute
}

const AppCCustomerSlugBikeModelsRouteChildren: AppCCustomerSlugBikeModelsRouteChildren =
  {
    AppCCustomerSlugBikeModelsIdRoute:
      AppCCustomerSlugBikeModelsIdRouteWithChildren,
    AppCCustomerSlugBikeModelsNewRoute: AppCCustomerSlugBikeModelsNewRoute,
    AppCCustomerSlugBikeModelsIndexRoute: AppCCustomerSlugBikeModelsIndexRoute,
  }

const AppCCustomerSlugBikeModelsRouteWithChildren =
  AppCCustomerSlugBikeModelsRoute._addFileChildren(
    AppCCustomerSlugBikeModelsRouteChildren,
  )

interface AppCCustomerSlugBikesRouteChildren {
  AppCCustomerSlugBikesIdRoute: typeof AppCCustomerSlugBikesIdRoute
  AppCCustomerSlugBikesNewRoute: typeof AppCCustomerSlugBikesNewRoute
  AppCCustomerSlugBikesIndexRoute: typeof AppCCustomerSlugBikesIndexRoute
}

const AppCCustomerSlugBikesRouteChildren: AppCCustomerSlugBikesRouteChildren = {
  AppCCustomerSlugBikesIdRoute: AppCCustomerSlugBikesIdRoute,
  AppCCustomerSlugBikesNewRoute: AppCCustomerSlugBikesNewRoute,
  AppCCustomerSlugBikesIndexRoute: AppCCustomerSlugBikesIndexRoute,
}

const AppCCustomerSlugBikesRouteWithChildren =
  AppCCustomerSlugBikesRoute._addFileChildren(
    AppCCustomerSlugBikesRouteChildren,
  )

interface AppCCustomerSlugLocationsRouteChildren {
  AppCCustomerSlugLocationsIdRoute: typeof AppCCustomerSlugLocationsIdRoute
  AppCCustomerSlugLocationsNewRoute: typeof AppCCustomerSlugLocationsNewRoute
  AppCCustomerSlugLocationsIndexRoute: typeof AppCCustomerSlugLocationsIndexRoute
}

const AppCCustomerSlugLocationsRouteChildren: AppCCustomerSlugLocationsRouteChildren =
  {
    AppCCustomerSlugLocationsIdRoute: AppCCustomerSlugLocationsIdRoute,
    AppCCustomerSlugLocationsNewRoute: AppCCustomerSlugLocationsNewRoute,
    AppCCustomerSlugLocationsIndexRoute: AppCCustomerSlugLocationsIndexRoute,
  }

const AppCCustomerSlugLocationsRouteWithChildren =
  AppCCustomerSlugLocationsRoute._addFileChildren(
    AppCCustomerSlugLocationsRouteChildren,
  )

interface AppCCustomerSlugMaterialsIdRouteChildren {
  AppCCustomerSlugMaterialsIdBikeModelsRoute: typeof AppCCustomerSlugMaterialsIdBikeModelsRoute
  AppCCustomerSlugMaterialsIdIndexRoute: typeof AppCCustomerSlugMaterialsIdIndexRoute
}

const AppCCustomerSlugMaterialsIdRouteChildren: AppCCustomerSlugMaterialsIdRouteChildren =
  {
    AppCCustomerSlugMaterialsIdBikeModelsRoute:
      AppCCustomerSlugMaterialsIdBikeModelsRoute,
    AppCCustomerSlugMaterialsIdIndexRoute:
      AppCCustomerSlugMaterialsIdIndexRoute,
  }

const AppCCustomerSlugMaterialsIdRouteWithChildren =
  AppCCustomerSlugMaterialsIdRoute._addFileChildren(
    AppCCustomerSlugMaterialsIdRouteChildren,
  )

interface AppCCustomerSlugMaterialsRouteChildren {
  AppCCustomerSlugMaterialsIdRoute: typeof AppCCustomerSlugMaterialsIdRouteWithChildren
  AppCCustomerSlugMaterialsImportRoute: typeof AppCCustomerSlugMaterialsImportRoute
  AppCCustomerSlugMaterialsImportRelationsRoute: typeof AppCCustomerSlugMaterialsImportRelationsRoute
  AppCCustomerSlugMaterialsNewRoute: typeof AppCCustomerSlugMaterialsNewRoute
  AppCCustomerSlugMaterialsIndexRoute: typeof AppCCustomerSlugMaterialsIndexRoute
}

const AppCCustomerSlugMaterialsRouteChildren: AppCCustomerSlugMaterialsRouteChildren =
  {
    AppCCustomerSlugMaterialsIdRoute:
      AppCCustomerSlugMaterialsIdRouteWithChildren,
    AppCCustomerSlugMaterialsImportRoute: AppCCustomerSlugMaterialsImportRoute,
    AppCCustomerSlugMaterialsImportRelationsRoute:
      AppCCustomerSlugMaterialsImportRelationsRoute,
    AppCCustomerSlugMaterialsNewRoute: AppCCustomerSlugMaterialsNewRoute,
    AppCCustomerSlugMaterialsIndexRoute: AppCCustomerSlugMaterialsIndexRoute,
  }

const AppCCustomerSlugMaterialsRouteWithChildren =
  AppCCustomerSlugMaterialsRoute._addFileChildren(
    AppCCustomerSlugMaterialsRouteChildren,
  )

interface AppCCustomerSlugTrackingRouteChildren {
  AppCCustomerSlugTrackingIndexRoute: typeof AppCCustomerSlugTrackingIndexRoute
}

const AppCCustomerSlugTrackingRouteChildren: AppCCustomerSlugTrackingRouteChildren =
  {
    AppCCustomerSlugTrackingIndexRoute: AppCCustomerSlugTrackingIndexRoute,
  }

const AppCCustomerSlugTrackingRouteWithChildren =
  AppCCustomerSlugTrackingRoute._addFileChildren(
    AppCCustomerSlugTrackingRouteChildren,
  )

interface AppCCustomerSlugDDocTypeSlugRouteChildren {
  AppCCustomerSlugDDocTypeSlugDocumentIdRoute: typeof AppCCustomerSlugDDocTypeSlugDocumentIdRoute
  AppCCustomerSlugDDocTypeSlugIndexRoute: typeof AppCCustomerSlugDDocTypeSlugIndexRoute
}

const AppCCustomerSlugDDocTypeSlugRouteChildren: AppCCustomerSlugDDocTypeSlugRouteChildren =
  {
    AppCCustomerSlugDDocTypeSlugDocumentIdRoute:
      AppCCustomerSlugDDocTypeSlugDocumentIdRoute,
    AppCCustomerSlugDDocTypeSlugIndexRoute:
      AppCCustomerSlugDDocTypeSlugIndexRoute,
  }

const AppCCustomerSlugDDocTypeSlugRouteWithChildren =
  AppCCustomerSlugDDocTypeSlugRoute._addFileChildren(
    AppCCustomerSlugDDocTypeSlugRouteChildren,
  )

interface AppCCustomerSlugReportingKpiOpsRouteChildren {
  AppCCustomerSlugReportingKpiOpsIndexRoute: typeof AppCCustomerSlugReportingKpiOpsIndexRoute
}

const AppCCustomerSlugReportingKpiOpsRouteChildren: AppCCustomerSlugReportingKpiOpsRouteChildren =
  {
    AppCCustomerSlugReportingKpiOpsIndexRoute:
      AppCCustomerSlugReportingKpiOpsIndexRoute,
  }

const AppCCustomerSlugReportingKpiOpsRouteWithChildren =
  AppCCustomerSlugReportingKpiOpsRoute._addFileChildren(
    AppCCustomerSlugReportingKpiOpsRouteChildren,
  )

interface AppCCustomerSlugReportingMaterialsBudgetRouteChildren {
  AppCCustomerSlugReportingMaterialsBudgetIndexRoute: typeof AppCCustomerSlugReportingMaterialsBudgetIndexRoute
}

const AppCCustomerSlugReportingMaterialsBudgetRouteChildren: AppCCustomerSlugReportingMaterialsBudgetRouteChildren =
  {
    AppCCustomerSlugReportingMaterialsBudgetIndexRoute:
      AppCCustomerSlugReportingMaterialsBudgetIndexRoute,
  }

const AppCCustomerSlugReportingMaterialsBudgetRouteWithChildren =
  AppCCustomerSlugReportingMaterialsBudgetRoute._addFileChildren(
    AppCCustomerSlugReportingMaterialsBudgetRouteChildren,
  )

interface AppCCustomerSlugRouteChildren {
  AppCCustomerSlugBikeModelsRoute: typeof AppCCustomerSlugBikeModelsRouteWithChildren
  AppCCustomerSlugBikesRoute: typeof AppCCustomerSlugBikesRouteWithChildren
  AppCCustomerSlugLocationsRoute: typeof AppCCustomerSlugLocationsRouteWithChildren
  AppCCustomerSlugMaterialsRoute: typeof AppCCustomerSlugMaterialsRouteWithChildren
  AppCCustomerSlugTrackingRoute: typeof AppCCustomerSlugTrackingRouteWithChildren
  AppCCustomerSlugDDocTypeSlugRoute: typeof AppCCustomerSlugDDocTypeSlugRouteWithChildren
  AppCCustomerSlugReportingKpiOpsRoute: typeof AppCCustomerSlugReportingKpiOpsRouteWithChildren
  AppCCustomerSlugReportingMaterialsBudgetRoute: typeof AppCCustomerSlugReportingMaterialsBudgetRouteWithChildren
  AppCCustomerSlugRequestsIdRoute: typeof AppCCustomerSlugRequestsIdRoute
  AppCCustomerSlugRequestsNewRoute: typeof AppCCustomerSlugRequestsNewRoute
  AppCCustomerSlugRequestsIndexRoute: typeof AppCCustomerSlugRequestsIndexRoute
}

const AppCCustomerSlugRouteChildren: AppCCustomerSlugRouteChildren = {
  AppCCustomerSlugBikeModelsRoute: AppCCustomerSlugBikeModelsRouteWithChildren,
  AppCCustomerSlugBikesRoute: AppCCustomerSlugBikesRouteWithChildren,
  AppCCustomerSlugLocationsRoute: AppCCustomerSlugLocationsRouteWithChildren,
  AppCCustomerSlugMaterialsRoute: AppCCustomerSlugMaterialsRouteWithChildren,
  AppCCustomerSlugTrackingRoute: AppCCustomerSlugTrackingRouteWithChildren,
  AppCCustomerSlugDDocTypeSlugRoute:
    AppCCustomerSlugDDocTypeSlugRouteWithChildren,
  AppCCustomerSlugReportingKpiOpsRoute:
    AppCCustomerSlugReportingKpiOpsRouteWithChildren,
  AppCCustomerSlugReportingMaterialsBudgetRoute:
    AppCCustomerSlugReportingMaterialsBudgetRouteWithChildren,
  AppCCustomerSlugRequestsIdRoute: AppCCustomerSlugRequestsIdRoute,
  AppCCustomerSlugRequestsNewRoute: AppCCustomerSlugRequestsNewRoute,
  AppCCustomerSlugRequestsIndexRoute: AppCCustomerSlugRequestsIndexRoute,
}

const AppCCustomerSlugRouteWithChildren =
  AppCCustomerSlugRoute._addFileChildren(AppCCustomerSlugRouteChildren)

interface AppRouteChildren {
  AppCustomerRoute: typeof AppCustomerRouteWithChildren
  AppSettingsRoute: typeof AppSettingsRouteWithChildren
  AppIndexRoute: typeof AppIndexRoute
  AppAdminBikeModelsRoute: typeof AppAdminBikeModelsRouteWithChildren
  AppAdminBikesRoute: typeof AppAdminBikesRouteWithChildren
  AppAdminCustomersRoute: typeof AppAdminCustomersRouteWithChildren
  AppAdminDevicesRoute: typeof AppAdminDevicesRouteWithChildren
  AppAdminFsmRoute: typeof AppAdminFsmRouteWithChildren
  AppAdminFsmWorkflowsRoute: typeof AppAdminFsmWorkflowsRouteWithChildren
  AppAdminKpisRoute: typeof AppAdminKpisRouteWithChildren
  AppAdminLocationsRoute: typeof AppAdminLocationsRouteWithChildren
  AppAdminMapRoute: typeof AppAdminMapRouteWithChildren
  AppAdminMaterialsRoute: typeof AppAdminMaterialsRouteWithChildren
  AppAdminNotificationChannelsRoute: typeof AppAdminNotificationChannelsRouteWithChildren
  AppAdminRolesRoute: typeof AppAdminRolesRouteWithChildren
  AppAdminStationsRoute: typeof AppAdminStationsRouteWithChildren
  AppAdminUsersRoute: typeof AppAdminUsersRouteWithChildren
  AppCCustomerSlugRoute: typeof AppCCustomerSlugRouteWithChildren
}

const AppRouteChildren: AppRouteChildren = {
  AppCustomerRoute: AppCustomerRouteWithChildren,
  AppSettingsRoute: AppSettingsRouteWithChildren,
  AppIndexRoute: AppIndexRoute,
  AppAdminBikeModelsRoute: AppAdminBikeModelsRouteWithChildren,
  AppAdminBikesRoute: AppAdminBikesRouteWithChildren,
  AppAdminCustomersRoute: AppAdminCustomersRouteWithChildren,
  AppAdminDevicesRoute: AppAdminDevicesRouteWithChildren,
  AppAdminFsmRoute: AppAdminFsmRouteWithChildren,
  AppAdminFsmWorkflowsRoute: AppAdminFsmWorkflowsRouteWithChildren,
  AppAdminKpisRoute: AppAdminKpisRouteWithChildren,
  AppAdminLocationsRoute: AppAdminLocationsRouteWithChildren,
  AppAdminMapRoute: AppAdminMapRouteWithChildren,
  AppAdminMaterialsRoute: AppAdminMaterialsRouteWithChildren,
  AppAdminNotificationChannelsRoute:
    AppAdminNotificationChannelsRouteWithChildren,
  AppAdminRolesRoute: AppAdminRolesRouteWithChildren,
  AppAdminStationsRoute: AppAdminStationsRouteWithChildren,
  AppAdminUsersRoute: AppAdminUsersRouteWithChildren,
  AppCCustomerSlugRoute: AppCCustomerSlugRouteWithChildren,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  PublicRoute: PublicRouteWithChildren,
  AppRoute: AppRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
